import Vue from "vue";
import VueRouter from "vue-router";
import VueBreadcrumbs from "vue-breadcrumbs";
import Callback from "./Components/Callback";
import App from "./App.vue";
import EmptyRouteView from "./Components/EmptyRouteView.vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Dashboard from "./Components/Dashboard/Dashboard.vue";
import AgentScoreDashboard from "./Components/Dashboard/AgentScoreDashboard.vue";
// Error
import Unauthorized from "./Components/Error/Unauthorized.vue";
// User
import UserList from "./Components/Master/User/UserList.vue";
import UserCreate from "./Components/Master/User/UserCreate.vue";
import UserUpdate from "./Components/Master/User/UserUpdate.vue";
import UserChangePassword from "./Components/Master/User/UserChangePassword.vue";
import AgentUserList from "./Components/Master/User/AgentUserList.vue";
import AgentUserCreate from "./Components/Master/User/AgentUserCreate.vue";
import AgentUserUpdate from "./Components/Master/User/AgentUserUpdate.vue";
// Role
import RoleList from "./Components/Master/Role/RoleList.vue";
import RoleForm from "./Components/Master/Role/RoleForm.vue";
// Holding
import HoldingList from "./Components/Master/Holding/HoldingList.vue";
import HoldingCreate from "./Components/Master/Holding/HoldingCreate.vue";
import HoldingUpdate from "./Components/Master/Holding/HoldingUpdate.vue";
import HoldingImport from "./Components/Master/Holding/HoldingImportModal.vue";
import HoldingExport from "./Components/Master/Holding/HoldingExportModal.vue";
// Search
// import SearchBeer from "./Components/Master/SearchBeer/SearchBeer.vue";
// import SearchDetail from "./Components/Master/SearchBeer/Detail.vue";
// Transport
import ManageTransport from "./Components/Master/Transport/ManageTransport.vue";
import CreateTransport from "./Components/Master/Transport/CreateTransport.vue";
import EditTransport from "./Components/Master/Transport/EditTransport.vue";
// Stock
import Plant from "./Components/Master/Plant/PlantList.vue";
import PlantCreate from "./Components/Master/Plant/PlantCreate.vue";
import PlantUpdate from "./Components/Master/Plant/PlantUpdate.vue";
// Shop
import ManageShop from "./Components/Master/Shop/ManageShop.vue";
import CreateShop from "./Components/Master/Shop/CreateShop.vue";
import EditShop from "./Components/Master/Shop/EditShop.vue";
import ExportShop from "./Components/Master/Shop/ManageShop.vue";

//AgentScore 
import AgentScoreList from "./Components/AgentScore/AgentScoreList.vue";
import JobAgentAuditStockReport from "./Components/Report/JobAgentAuditStock.vue";
import KegRotationScoreReport from "./Components/Report/KegRotationScore.vue";
import KegRotationScoreAgentReport from "./Components/Report/KegRotationScoreAgent.vue";
import AgentStockOverdueReport from "./Components/Report/AgentStockOverdue.vue";

// ShopChangeRequest
import ManageShopChangeRequest from "./Components/Master/ShopChangeRequest/ManageShopChangeRequest.vue";
import DetailShopChangeRequest from "./Components/Master/ShopChangeRequest/DetailShopChangeRequest.vue";

// ShopProfile
// import ManageShopProfile from "./Components/Master/ShopProfile/ManageShopProfile.vue";
// import CreateShopProfile from "./Components/Master/ShopProfile/CreateShopProfile.vue";
// import EditShopProfile from "./Components/Master/ShopProfile/EditShopProfile.vue";
// import DetailShopProfile from "./Components/Master/ShopProfile/DetailShopProfile.vue";

// ShopSubAgent
import ManageShopSubAgent from "./Components/Master/ShopSupAgent/ManageShopSubAgent.vue";
import CreateShopSubAgent from "./Components/Master/ShopSupAgent/CreateShopSubAgent.vue";
import EditShopSubAgent from "./Components/Master/ShopSupAgent/EditShopSubAgent.vue";
//Agent
import Agents from "./Components/Master/Agent/AgentList.vue";
import AgentCreate from "./Components/Master/Agent/AgentCreate.vue";
import AgentCreateExcel from "./Components/Master/Agent/AgentCreateExcel.vue";
import AgentUpdate from "./Components/Master/Agent/AgentUpdate.vue";
// import Test from "./Components/Master/Agent/TestPlUpload.vue";
import ExportAgent from "./Components/Master/Agent/AgentList.vue";

// Product
import Product from "./Components/Master/Product/ProductList.vue";
import CreateProduct from "./Components/Master/Product/CreateProduct.vue";
import ProductDetail from "./Components/Master/Product/ProductDetail.vue";
import ProductUpdate from "./Components/Master/Product/ProductUpdate.vue";
// Brand
import ManageBrand from "./Components/Master/Brand/BrandList.vue";
import CreateBrand from "./Components/Master/Brand/BrandCreate.vue";
import EditBrand from "./Components/Master/Brand/BrandUpdate.vue";
import ExportBrand from "./Components/Master/Brand/BrandExportModal.vue";
//Stock Product
// import ManageStockProduct from "./Components/Master/StockProduct/ManageStockProduct.vue";
// import UpdateStockProduct from "./Components/Master/StockProduct/StockProductUpdate.vue";
//Supplier
import Supplier from "./Components/Master/Supplier/SupplierList.vue";
import SupplierUpdate from "./Components/Master/Supplier/SupplierUpdate.vue";
import ExportSuplier from "./Components/Master/Supplier/SupplierList.vue";
//Upload stock beand
// import UploadStockBrand from "./Components/Master/ImportStockProduct/ImportStockProduct.vue";
//Test create table
// import TestCreate from "./Components/Master/ImportStockProduct/Test.vue";
//Contact
import Contact from "./Components/Master/Contact/ContactList.vue";
import ContactCreate from "./Components/Master/Contact/ContactCreate.vue";
import ContactUpdate from "./Components/Master/Contact/ContactUpdate.vue";
//BorrowProduct
import ManageBorrowProduct from "./Components/Borrow/ManageBorrowProducts.vue"; //"./Components/Borrow/ManageBorrowProducts.vue";
import CreateBorrowProduct from "./Components/Borrow/CreateBorrowProduct.vue";
import BRPictureModal from "./Components/Borrow/PictureModal.vue";
import UpdateBorrowProduct from "./Components/Borrow/UpdateBorrowProduct.vue";
import DetialBorrowProduct from "./Components/Borrow/DetialBorrowProduct.vue";
import JobBorrowProduct from "./Components/Borrow/JobBorrowProduct.vue";
import JobBorrowProductReturn from "./Components/Borrow/JobBorrowProductReturn.vue";
//CheckHoldProduct
// import ManageCheckHoldProduct from "./Components/Master/CheckHoldProduct/ListCheckHoldProduct.vue";
// import UpdateCheckHoldProduct from "./Components/Master/CheckHoldProduct/UpdateCheckHoldProduct.vue";
//Barcode
import ManageBarcode from "./Components/Master/Barcode/ManageBarcode.vue";
import CreateBarcode from "./Components/Master/Barcode/CreateBarcode.vue";
import UpdateBarcode from "./Components/Master/Barcode/UpdateBarcode.vue";
import DetailBarcode from "./Components/Master/Barcode/DetailBarcode.vue";
import TemplateBarcode from "./Components/Master/Barcode/TemplateBarcode.vue";
import ImportBarcode from "./Components/Master/Barcode/ImportBarcode.vue";
import DownloadBarcode from "./Components/Master/Barcode/DownloadBarcode.vue";
import EditBarcode from "./Components/Master/Barcode/EditBarcode.vue";
// Job
import JobList from "./Components/Job/JobList.vue";
import JobForm from "./Components/Job/JobForm.vue";
import JobCNForm from "./Components/Job/JobCNForm.vue";
// CR-Job-Stock — ใบงานตัดยอดคงค้าง (Write-off Outstanding Stock)
import WriteOffStockJobForm from "./Components/WriteOffStockJob/WriteOffStockJobForm.vue";
// Order
import OrderList from "./Components/Master/Order/OrderList.vue";
import OrderCreate from "./Components/Master/Order/OrderCreate.vue";
import OrderDetail from "./Components/Master/Order/OrderDetail.vue";
import OrderUpdate from "./Components/Master/Order/OrderUpdate.vue";
//Approver
import ApproverList from "./Components/Master/Approver/ApproverList.vue";
import CreateApprover from "./Components/Master/Approver/CreateApprover.vue";
import ApproverAgentInfo from "./Components/Master/Approver/ApproverAgentInfo.vue";
import ApproverEmployeeInfo from "./Components/Master/Approver/ApproverEmployeeInfo.vue";
import ApproverUserInfo from "./Components/Master/Approver/ApproverUserInfo.vue";
import UpdateApprover from "./Components/Master/Approver/UpdateApprover.vue";
//CustomerProfile
import CompanyProfileList from "./Components/Master/CompanyProfile/CompanyProfileList.vue";
import CreateCompanyProfile from "./Components/Master/CompanyProfile/CompanyProfileCreate.vue";
import UpdateCompanyProfile from "./Components/Master/CompanyProfile/CompanyProfileUpdate.vue";
 
//Report
import JobAgentScoreReport from "./Components/Report/JobAgentScore.vue";
import AgentScoreEvaluationReport from "./Components/Report/AgentScoreEvaluationReport.vue";
import JobRetrieveReport from "./Components/Report/JobRetrieve.vue";
import AssetProductsReport from "./Components/Report/AssetProducts.vue";
import MovementReport from "./Components/Report/Movement.vue";
import FixedProductsReport from "./Components/Report/FixedProducts.vue";
import ProduceProductsReport from "./Components/Report/ProduceProducts.vue";
import BrandCountReport from "./Components/Report/BrandCount.vue";
import AgentAssetsReport from "./Components/Report/AgentAssets.vue";
import ShopAssetsReport from "./Components/Report/ShopAssets.vue";
import TransferBarcodeReport from "./Components/Report/TransferBarcode.vue";
import TransferBarcodeMultipleReport from "./Components/Report/TransferBarcodeMultiple.vue";
import TransferBarcodeSubAgentReport from "./Components/Report/TransferBarcodeSubAgent.vue";
import BarcodesReport from "./Components/Report/Barcodes.vue";
import AverageBarcodeReport from "./Components/Report/AverageBarcode.vue";
import StockBarcodeSnapshotReport from "./Components/Report/StockBarcodeSnapshot.vue";
import BarcodeStatusReport from "./Components/Report/BarcodeStatus.vue";
import BrandCountBarcodeModal from "./Components/Report/BrandCountBarcodeModal.vue";
import ProductStocksReport from "./Components/Report/ProductStocks.vue";
import TransferBarcodeSupplierReport from "./Components/Report/TransferBarcodeSupplier.vue";
import BorrowReport from "./Components/Report/Borrow.vue";
import QIGroupByAgentReport from "./Components/Report/QIGroupByAgent.vue";
import QIGroupByOfficerReport from "./Components/Report/QIGroupByOfficer.vue";
import NewShopOnOffPremiseReport from "./Components/Report/NewShopOnOffPremise.vue";
import TransactionView5SReport from "./Components/Report/TransactionView5S.vue";
import EvaluateView5SReport from "./Components/Report/EvaluateView5S.vue";
import WarehouseScoreReport from "./Components/Report/WarehouseScore.vue";
import NotificationKPIReport from "./Components/Report/NotificationKPI.vue";
import EventAndFoodReport from "./Components/Report/EventAndFood.vue";
import SurveyOnOffPremiseReport from "./Components/Report/SurveyOnOffPremise.vue";
import StatusBeerClaimMonthlyReport from "./Components/Report/StatusBeerClaimMonthly.vue";
import InvoiceReport from "./Components/Report/Invoice.vue";
import AmountBeerClaimReport from "./Components/Report/AmountBeerClaim.vue";
import CostBeerClaimReport from "./Components/Report/CostBeerClaim.vue";
import LeaseMachineReport from "./Components/Report/LeaseMachine.vue";
import MachineDetailReport from "./Components/Report/MachineDetail.vue";
import PMMonthlyReport from "./Components/Report/PMMonthly.vue";
import MTMonthlyReport from "./Components/Report/MTMonthly.vue";
import PMRoutePlanReport from "./Components/Report/PMRoutePlan.vue";
import PMSpareReport from "./Components/Report/PMSpare.vue";
import PMAlertSummaryReport from "./Components/Report/PMAlertSummary.vue";
import PMReport from "./Components/Report/PM.vue";
import PMSurveyReport from "./Components/Report/PMSurvey.vue";
import MasterShopOnOffReport from "./Components/Report/MasterShopOnOff.vue";
import BarButlerByBrandReport from "./Components/Report/BarButlerByBrand.vue";
import PaymentProductReport from "./Components/Report/PaymentProduct.vue";
import ReturnProductReport from "./Components/Report/ReturnProduct.vue";
import BarcodeMappingReport from "./Components/Report/BarcodeMappingReport.vue";

import PMOperationReport from "./Components/Report/PMOperationReport.vue";

// ReportAlert
import OverdueAll from "./Components/ReportAlert/OverdueAll.vue";
//BeforeDue
import BeforeDue from "./Components/ReportAlert/BeforeDue.vue";

// Aler PM Config 
import AlertPMConfigList from "./Components/Master/AlertPMConfig/PMList.vue";
import AlertPMConfigCreate from "./Components/Master/AlertPMConfig/Create.vue";
import AlertPMConfigEdit from "./Components/Master/AlertPMConfig/Edit.vue";
 
//AdminReport
// import PMReport from "./Components/AdminReport/PM.vue";
// import MasterShopOnOffReport from "./Components/AdminReport/MasterShopOnOff.vue";
import MasterShopByBrandReport from "./Components/AdminReport/MasterShopByBrand.vue";
// import BarButlerByBrandReport from "./Components/AdminReport/BarButlerByBrand.vue";
import JobIssueReport from "./Components/AdminReport/JobIssue.vue";
import AlertPMReport from "./Components/AdminReport/AlertPM.vue";
import SurveyReport from "./Components/AdminReport/Survey.vue";

//Setting
import Setting from "./Components/Master/Setting/ManageSetting.vue";

//QICheckIn
import QICheckInList from "./Components/QICheckIn/CheckInList.vue";
import QICheckInDetail from "./Components/QICheckIn/CheckInDetail.vue";
import QIPictureModal from "./Components/QICheckIn/PictureModal.vue";

//QIJob
import QIJobList from "./Components/QIJob/QIJobList.vue";
import QIJobDetail from "./Components/QIJob/QIJobDetail.vue";
import QIJobEditDrawback from "./Components/QIJob/QIJobEditDrawback.vue";
import QIJobEditRepair from "./Components/QIJob/QIJobEditRepair.vue";
import QIRecvList from "./Components/QIJob/QIRecvList.vue";
import QIRecvDetail from "./Components/QIJob/QIRecvDetail.vue";
import QIRecvCreate from "./Components/QIJob/QIRecvBorrow.vue";
import QIStockList from "./Components/QIJob/QIStockList.vue";

//QIJob Report
import StockPendingReport from "./Components/QIJob/ReportStockPending.vue";
import CheckerReport from "./Components/QIJob/ReportChecker.vue";
import SparePartsUsedReport from "./Components/QIJob/ReportSparePartsUsed.vue";
import SparePartsStockReport from "./Components/QIJob/ReportSparePartsStock.vue";
import DrawbackReport from "./Components/QIJob/ReportDrawback.vue";
import RepairSumReport from "./Components/QIJob/ReportRepairSum.vue";
import ReportRepairUsage from "./Components/QIJob/ReportRepairUsage.vue";
import ReportQISummary from "./Components/QIJob/ReportQISummary.vue";

//ProductBrand
import ProductBrandList from "./Components/Master/ProductBrand/ProductBrandList.vue";
import CreateProductBrand from "./Components/Master/ProductBrand/ProductBrandCreate.vue";
import ProductBrandUpdate from "./Components/Master/ProductBrand/ProductBrandUpdate.vue";

//Marketing
import MarketingList from "./Components/Marketing/MarketingList.vue";
import MarketingDetail from "./Components/Marketing/MarketingDetail.vue";
import MarketingApproveDetail from "./Components/Marketing/MarketingApproveDetail.vue";

//KPI
import ProductSlow from "./Components/KPI/Products/ProductSlow.vue";
import ProductExpire from "./Components/KPI/Products/ProductExpire.vue";
import ProductLost from "./Components/KPI/Products/ProductLost.vue";
import ProductDilapidated from "./Components/KPI/Products/ProductDilapidated.vue";
import AccessoriesDilapidated from "./Components/KPI/Products/AccessoriesDilapidated.vue";
import AccessoriesLost from "./Components/KPI/Products/AccessoriesLost.vue";
import ProductCycle from "./Components/KPI/Products/ProductCycle.vue";
import DamageMach from "./Components/KPI/Products/DamageMach.vue";
import LostMach from "./Components/KPI/Products/LostMach.vue";
import LostTank from "./Components/KPI/Products/LostTank.vue";

//E-Learning
import ManageELearning from "./Components/5S/ManageELearning.vue";
import FolderELearningModal from "./Components/5S/FolderELearningModal.vue";
import CreateSubFolderELearningModal from "./Components/5S/CreateSubFolderELearningModal.vue";
import DetialsELearning from "./Components/5S/DetialsELearning.vue";
import UpdateELearning from "./Components/5S/UpdateELearning.vue";

//PM
import SearchPMRoutePlan from "./Components/PM/SearchPMRoutePlan.vue";
import AddPMRoutePlan from "./Components/PM/AddPMRoutePlan.vue";
import EditPMRoutePlan from "./Components/PM/EditPMRoutePlan.vue";
import SearchCheckIn from "./Components/PM/SearchCheckIn.vue";
import BarcodeMappingDetail from "./Components/PM/BarcodeMappingDetail.vue";
import PMDetail from "./Components/PM/PMDetail.vue";
import MTDetail from "./Components/PM/MTDetail.vue";
import PMPictureModal from "./Components/PM/PictureModal.vue";

//PM Survey CheckIn
import SearchSurveyCheckIn from "./Components/PM/SearchSurveyCheckIn.vue";
import PMSurveyBarcodeMappingDetail  from "./Components/PM/PMSurveyBarcodeMappingDetail.vue";
import PMSurveyDetail from "./Components/PM/PMSurveyDetail.vue";
// import MTDetail from "./Components/PM/MTDetail.vue";
import PMSurveyPictureModal from "./Components/PM/SurveyPictureModal.vue";

//BeerClaim
import SearchBeerClaim from "./Components/BeerClaim/SearchBeerClaim.vue";
import AddBeerClaim from "./Components/BeerClaim/AddBeerClaim.vue";
import AddBeerClaimItem from "./Components/BeerClaim/AddBeerClaimItem.vue";
import EditBeerClaim from "./Components/BeerClaim/EditBeerClaim.vue";
import CommitBeerClaim from "./Components/BeerClaim/CommitBeerClaim.vue";
import ResultBeerClaim from "./Components/BeerClaim/ResultBeerClaim.vue";
import ApproveBeerClaim from "./Components/BeerClaim/ApproveBeerClaim.vue";
import ConcludeApproveBeerClaim from "./Components/BeerClaim/ConcludeApproveBeerClaim.vue";
import BeerClaimDetail from "./Components/BeerClaim/BeerClaimDetail.vue";
import BeerClaimItemDetail from "./Components/BeerClaim/BeerClaimItemDetail.vue";

//Phase
import ManagePhase from "./Components/Master/Phase/ManagePhase.vue";
//import TemplatePhase from "./Components/Master/Barcode/TemplateBarcode.vue";
import ImportPhase from "./Components/Master/Phase/ImportPhase.vue";
import DownloadPhase from "./Components/Master/Phase/DownloadPhase.vue";

//Phase
import ManageMachineTransaction from "./Components/Master/MachineTransaction/ManageMachineTransaction.vue";
//import TemplatePhase from "./Components/Master/Barcode/TemplateBarcode.vue";
import ImportMachineTransaction from "./Components/Master/MachineTransaction/ImportMachineTransaction.vue";
import DownloadMachineTransaction from "./Components/Master/MachineTransaction/DownloadMachineTransaction.vue";

//MachinPayment
import SaveBillingMachinePayment from "./Components/Machine/SaveBillingMachinePayment.vue";
import PaymentMachinePayment from "./Components/Machine/PaymentMachinePayment.vue";
import ListMachine from "./Components/Machine/ListMachine.vue";

//MachinPayment
import SalesAreaList from "./Components/Master/SalesArea/SalesAreaList.vue";
import SalesAreaCreate from "./Components/Master/SalesArea/SalesAreaCreate.vue";
import SalesAreaUpdate from "./Components/Master/SalesArea/SalesAreaUpdate.vue";

// Alert ถัง
import OverdueSettingList from "./Components/Master/OverdueSetting/OverdueSettingList.vue";
import CreateOverdueSetting from "./Components/Master/OverdueSetting/OverdueSettingCreate.vue";
import EditOverdueSetting from "./Components/Master/OverdueSetting/OverdueSettingUpdate.vue";
// ราคาค่าถัง
import MasterProductUnitPriceList from "./Components/Master/MasterProductUnitPrice/MasterProductUnitPriceList.vue";
import CreateMasterProductUnitPrice from "./Components/Master/MasterProductUnitPrice/MasterProductUnitPriceCreate.vue";
import EditMasterProductUnitPrice from "./Components/Master/MasterProductUnitPrice/MasterProductUnitPriceUpdate.vue";

// Budget Plan
import BudgetPlanList from "./Components/BudgetPlan/BudgetPlanList.vue";
import BudgetJob from "./Components/BudgetPlan/BudgetJob.vue";
import BudgetPlanDetail from "./Components/BudgetPlan/BudgetPlanDetail.vue";
import BudgetPlanCreate from "./Components/BudgetPlan/BudgetPlanCreate.vue";
import BudgetPlanJobList from "./Components/BudgetPlan/BudgetPlanJobList.vue";
import BudgetPlanJobCreate from "./Components/BudgetPlan/BudgetPlanJobCreate.vue";
import ApproveGroupList from "./Components/BudgetPlan/ApproveGroupList.vue";
import ApproveGroupForm from "./Components/BudgetPlan/ApproveGroupForm.vue";
import BudgetPlanGroupApprove from "./Components/BudgetPlan/BudgetPlanGroupApprove.vue";
import BudgetPlanMonitoring from "./Components/BudgetPlan/BudgetPlanMonitoring.vue";
import VendorUsageReport from "./Components/BudgetPlan/VendorUsageReport.vue";
import BudgetPlanMonitoringSendApprovalGroup from "./Components/BudgetPlan/BudgetPlanMonitoringSendApprovalGroup.vue";
import BudgetPlanMonitoringBiSnapData from "./Components/BudgetPlan/BudgetPlanMonitoringBiSnapData.vue";
import StockCoverDaysList from "./Components/StockCoverDays/StockCoverDaysList.vue";
import StockCoverDaysCreate from "./Components/StockCoverDays/StockCoverDaysCreate.vue";
import StockCoverDaysDetail from "./Components/StockCoverDays/StockCoverDaysDetail.vue";
import StockCoverDaysReportAnalysis from "./Components/StockCoverDays/StockCoverDaysReportAnalysis.vue";
import StockCoverDaysDashboard from "./Components/StockCoverDays/StockCoverDaysDashboard.vue";
import StockCoverDaysReport from "./Components/StockCoverDays/StockCoverDaysReport.vue";
import MonitoringScheduledJobs from "./Components/Monitoring/MonitoringScheduledJobs.vue";
import MonitoringSendEmailReportAgent from "./Components/Monitoring/MonitoringSendEmailReportAgent.vue";
import MonitoringClearImage from "./Components/Monitoring/MonitoringClearImage.vue";
import MonitoringHub from "./Components/Monitoring/MonitoringHub.vue";
import MonitoringScvd from "./Components/Monitoring/MonitoringScvd.vue";
// CR-FormSummaryStock — เอกสารสรุปสินค้าคงค้าง
import FormSummaryStockList from "./Components/PrintSummary/FormSummaryStockList.vue";
import FormSummaryStockCreate from "./Components/PrintSummary/FormSummaryStockCreate.vue";
import FormSummaryStockPreview from "./Components/PrintSummary/FormSummaryStockPreview.vue";
import FormSummaryStockGroupPreview from "./Components/PrintSummary/FormSummaryStockGroupPreview.vue";
import FormSummaryStockDetail from "./Components/PrintSummary/FormSummaryStockDetail.vue";
import FormSummaryStockGroupResult from "./Components/PrintSummary/FormSummaryStockGroupResult.vue";

Vue.use(VueRouter);
Vue.use(VueGoogleMaps, {
  load: {
    key: "REPLACE-THIS-WITH-YOUR-KEY-FROM-ABOVE",
    libraries: "places", // necessary for places input
  },
});
Vue.use(VueBreadcrumbs, {
  template:
    '<div class="kt-subheader__breadcrumbs"><router-link to="/" class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter"></i></router-link>' +
    '<template v-for="(crumb, key) in $breadcrumbs"><span class="kt-subheader__breadcrumbs-separator"></span><router-link class="kt-subheader__breadcrumbs-link" :to="linkProp(crumb)" :key="key">{{ crumb | crumbText }}</router-link></template>' +
    "</div>",
});

const routes = [
  {
    path: "/",
    component: App,
    meta: {
      requiredAuth: true,
      requiredRoles: [],
    },
    children: [
      {
        path: "",
        component: Dashboard,
        meta: {
          breadcrumb: "แดชบอร์ด",
          requiredAuth: true,
          requiredRoles: ["DASHBOARD"],
        },
      },
      {
        path: "/AgentScoreDashboard",
        component: AgentScoreDashboard,
        meta: {
          breadcrumb: "คะแนนตัวแทนจำหน่าย",
          requiredAuth: true,
          requiredRoles: ["AGENT_REPORT", "BR_REPORT", "AGENT_SCORE_ADMIN"],
          excludedProfileTypes: ["COMPANY_PROFILE_TYPE_BR"],
        },
      },
      {
        path: "/AgentStockOverdue",
        component: AgentStockOverdueReport,
        meta: {
          breadcrumb: "รายงาน STOCK ระบบเบียร์สด",
          requiredAuth: true,
          requiredRoles: ["AGENT_REPORT", "BR_REPORT", "AGENT_SCORE_ADMIN", "BR_DASHBOARD_AUDIT_STOCK"],
          excludedProfileTypes: ["COMPANY_PROFILE_TYPE_BR"],
        },
      },
      {
        path: "/Error",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "ข้อผิดพลาด",
          requiredAuth: false,
          defaultChild: "Unauthorized",
        },
        children: [
          {
            path: "Unauthorized",
            component: Unauthorized,
            meta: {
              breadcrumb: "ไม่มีสิทธิ์เข้าใช้งาน",
              requiredAuth: false,
            },
          },
        ],
      },
      {
        path: "/Master",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "ข้อมูลพื้นฐาน",
          requiredAuth: true,
          defaultChild: "Users",
        },
        children: [
          {
            path: "Users",
            component: UserList,
            meta: {
              breadcrumb: "สมาชิก",
              requiredAuth: true,
              requiredRoles: ["MASTER_USER"],
            },
            children: [
              {
                path: "Add",
                component: UserCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลสมาชิก",
                  requiredAuth: true,
                  requiredRoles: ["MASTER_USER"],
                },
              },
              {
                path: "Edit/:userId",
                component: UserUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลสมาชิก",
                  requiredAuth: true,
                  requiredRoles: ["MASTER_USER"],
                },
              },
              {
                path: "ChangePassword/:userId",
                component: UserChangePassword,
                meta: {
                  breadcrumb: "แก้ไขรหัสผ่านสมาชิก",
                  requiredAuth: true,
                  requiredRoles: ["MASTER_USER"],
                },
              },
            ],
          },
          {
            path: "AgentUsers",
            component: AgentUserList,
            meta: {
              breadcrumb: "จัดการข้อมูลสมาชิกตัวแทน/ตัวแทนจำหน่ายย่อย",
              requiredAuth: true,
              requiredRoles: ["MANAGE_SUB_AGENT_USER"],
            },
            children: [
              {
                path: "Add",
                component: AgentUserCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลสมาชิก",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_SUB_AGENT_USER"],
                },
              },
              {
                path: "Edit/:userId",
                component: AgentUserUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลสมาชิก",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_SUB_AGENT_USER"],
                },
              },
            ],
          },
          {
            path: "Roles",
            component: RoleList,
            meta: {
              breadcrumb: "บทบาท",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MASTER_ROLE"],
            },
            children: [
              {
                path: "Add",
                component: RoleForm,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลบทบาท",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_ROLE"],
                },
              },
              {
                path: "Edit/:roleName",
                component: RoleForm,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลบทบาท",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_ROLE"],
                },
              },
            ],
          },
          {
            path: "Holding",
            component: HoldingList,
            meta: {
              breadcrumb: "ระยะเวลาถือครองสินค้า",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"],
            },
            children: [
              {
                path: "Add",
                component: HoldingCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลการถือครอง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"],
                },
              },
              {
                path: "Edit/:id",
                component: HoldingUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลการถือครอง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"],
                },
              },
              {
                path: "Import",
                component: HoldingImport,
                meta: {
                  breadcrumb: "Import ข้อมูลการถือครอง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"],
                },
              },
              {
                path: "Export",
                component: HoldingExport,
                meta: {
                  breadcrumb: "Export ข้อมูลการถือครอง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_HOLDING"],
                },
              },
            ],
          },
          {
            path: "ManageTransport",
            component: ManageTransport,
            meta: {
              breadcrumb: "จัดการข้อมูลขนส่ง",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_TRANSPORT"],
            },
            children: [
              {
                path: "Add",
                component: CreateTransport,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลขนส่ง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_TRANSPORT"],
                },
              },
              {
                path: "Edit/:id",
                component: EditTransport,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลขนส่ง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_TRANSPORT"],
                },
              },
            ],
          }, 
          {
            path: "Plant",
            component: Plant,
            meta: {
              breadcrumb: "จัดการข้อมูลคลังสินค้า",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_PLANT"],
            },
            children: [
              {
                path: "Add",
                component: PlantCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลคลังสินค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PLANT"],
                },
              },
              {
                path: "Edit/:Plantid",
                component: PlantUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลคลังสินค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PLANT"],
                },
              },
            ],
          },
          {
            path: "ManageShop",
            component: ManageShop,
            meta: {
              breadcrumb: "จัดการข้อมูลร้านค้า",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"],
            },
            children: [
              {
                path: "Add",
                component: CreateShop,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลร้านค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"],
                },
              },
              {
                path: "Edit/:id",
                component: EditShop,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลร้านค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"],
                },
              },
              {
                path: "ExportShop",
                component: ExportShop,
                meta: {
                  breadcrumb: "Export ข้อมูลร้านค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"],
                },
              },
              {
                path: "ExportAgent",
                component: ExportAgent,
                meta: {
                  breadcrumb: "Export ข้อมูลตัวแทนจำหน่าย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"],
                },
              },
              {
                path: "ExportSuplier",
                component: ExportSuplier,
                meta: {
                  breadcrumb: "Export ข้อมูลSuplier",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP"],
                },
              },
            ],
          },
          {
            path: "ManageShopChangeRequest",
            component: ManageShopChangeRequest,
            meta: {
              breadcrumb: "จัดการขอแก้ไขข้อมูลร้านค้า",
              requiredAuth: true,
              requiredRoles: [
                "MANAGE_MASTER",
                "MANAGE_SHOP_CHANGE_REQUEST",
                "ADMIN_MKT",
                "ADMIN_PM",
                "ADMIN_QI",
                "MANAGER_MKT",
                "MANAGER_QI",
                "USER_QI",
                "USER_MKT",
              ],
            },
            children: [
              {
                path: "Detail/:id",
                component: DetailShopChangeRequest,
                meta: {
                  breadcrumb: "รายละเอียดขอแก้ไขข้อมูลร้านค้า",
                  requiredAuth: true,
                  requiredRoles: [
                    "MANAGE_MASTER",
                    "MANAGE_SHOP_CHANGE_REQUEST",
                    "ADMIN_MKT",
                    "ADMIN_PM",
                    "ADMIN_QI",
                    "MANAGER_MKT",
                    "MANAGER_QI",
                    "USER_QI",
                  ],
                },
              },
            ],
          },
          // {
          //   path: "ManageShopProfile",
          //   component: ManageShopProfile,
          //   meta: {
          //     breadcrumb: "จัดการข้อมูลโปรไฟล์ร้านค้า",
          //     requiredAuth: true,
          //     requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
          //   },
          //   children: [
          //     {
          //       path: "Add",
          //       component: CreateShopProfile,
          //       meta: {
          //         breadcrumb: "เพิ่มข้อมูลโปรไฟล์ร้านค้า",
          //         requiredAuth: true,
          //         requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
          //       },
          //     },
          //     {
          //       path: "Edit/:id",
          //       component: EditShopProfile,
          //       meta: {
          //         breadcrumb: "แก้ไขข้อมูลโปรไฟล์ร้านค้า",
          //         requiredAuth: true,
          //         requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
          //       },
          //     },
          //     {
          //       path: "Detail/:id",
          //       component: DetailShopProfile,
          //       meta: {
          //         breadcrumb: "รายละเอียดข้อมูลโปรไฟล์ร้านค้า",
          //         requiredAuth: true,
          //         requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOPPROFILE"],
          //       },
          //     },
          //   ],
          // },
          {
            path: "ManageShopSubAgent",
            component: ManageShopSubAgent,
            meta: {
              breadcrumb: "จัดการข้อมูลร้านค้าตัวแทนจำหน่ายย่อย",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"],
            },
            children: [
              {
                path: "Add",
                component: CreateShopSubAgent,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลร้านค้าตัวแทนจำหน่ายย่อย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"],
                },
              },
              {
                path: "Edit/:id",
                component: EditShopSubAgent,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลร้านค้าตัวแทนจำหน่ายย่อย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SHOP_SUB_AGENT"],
                },
              },
            ],
          },
          {
            path: "Agents",
            component: Agents,
            meta: {
              breadcrumb: "จัดการข้อมูลตัวแทนจำหน่าย",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"],
            },
            children: [
              {
                path: "Add",
                component: AgentCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลตัวแทนจำหน่าย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"],
                },
              },
              {
                path: "AddExcel",
                component: AgentCreateExcel,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลตัวแทนจำหน่าย(Excel)",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"],
                },
              },
              {
                path: "Edit/:AgentID",
                // component: Test,
                component: AgentUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลตัวแทนจำหน่าย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MASTER_AGENT"],
                },
              },
            ],
          },
          {
            path: "Product",
            component: Product,
            meta: {
              breadcrumb: "จัดการข้อมูลสินค้า",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"],
            },
            children: [
              {
                path: "Add",
                component: CreateProduct,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลสินค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"],
                },
              },
              {
                path: "Detail/:id",
                component: ProductDetail,
                meta: {
                  breadcrumb: "รายละเอียดข้อมูลสินค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"],
                },
              },
              {
                path: "Update/:id",
                component: ProductUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลสินค้า",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCT"],
                },
              },
            ],
          },
          {
            path: "ManageBrand",
            component: ManageBrand,
            meta: {
              breadcrumb: "จัดการงบประมาณ",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"],
            },
            children: [
              {
                path: "Add",
                component: CreateBrand,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลงบประมาณแบรนด์",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"],
                },
              },
              {
                path: "Edit/:id",
                component: EditBrand,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลงบประมาณแบรนด์",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"],
                },
              },
              {
                path: "Export",
                component: ExportBrand,
                meta: {
                  breadcrumb: "ข้อมูลงบประมาณแบรนด์",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_BRAND"],
                },
              },
            ],
          },
          {
            path: "Supplier",
            component: Supplier,
            meta: {
              breadcrumb: "จัดการข้อมูล Supplier",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SUPPLIER"],
            },
            children: [
              {
                path: "Update/:id",
                component: SupplierUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูล Supplier",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SUPPLIER"],
                },
              },
            ],
          },
          {
            path: "Contact",
            component: Contact,
            meta: {
              breadcrumb: "ข้อมูลผู้ติดต่อ",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_CONTACT"],
            },
            children: [
              {
                path: "Add",
                component: ContactCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลผู้ติดต่อ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_CONTACT"],
                },
              },
              {
                path: "Update/:id",
                component: ContactUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลผู้ติดต่อ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_CONTACT"],
                },
              },
            ],
          },
          {
            path: "AlertPMConfig",
            component: AlertPMConfigList,
            meta: {
              breadcrumb: "จัดการข้อมูลวัน Alert PM",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
            },
            children: [
              {
                path: "Add",
                component: AlertPMConfigCreate,
                meta: {
                  breadcrumb: "เพิ่ม จัดการข้อมูลวัน Alert PM",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
                },
              },
              {
                path: "Edit/:id",
                component: AlertPMConfigEdit,
                meta: {
                  breadcrumb: "แก้ไข จัดการข้อมูลวัน Alert PM",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
                },
              },
            ],
          }, 
          {
            path: "ManageBarcode",
            component: ManageBarcode,
            meta: {
              breadcrumb: "จัดการข้อมูล BARCODE",
              requiredAuth: true,
            },
            children: [
              {
                path: "Add",
                component: CreateBarcode,
                meta: { breadcrumb: "เพิ่มข้อมูล BARCODE", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "Edit/:id",
                component: UpdateBarcode,
                meta: { breadcrumb: "แก้ไขข้อมูล BARCODE", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "Detail/:id",
                component: DetailBarcode,
                meta: { breadcrumb: "รายละเอียด BARCODE", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "TemplateBarcode",
                component: TemplateBarcode,
                meta: { breadcrumb: "Template Barcode", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "Import",
                component: ImportBarcode,
                meta: { breadcrumb: "Import Barcode", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "DownloadBarcode",
                component: DownloadBarcode,
                meta: { breadcrumb: "Download Barcode", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "EditBarcode/:id",
                component: EditBarcode,
                meta: { breadcrumb: "แก้ไขบาร์โค้ด", requiredRoles: ["MANAGE_MASTER"] },
              },
              {
                path: "Detail/:id",
                component: DetailBarcode,
                meta: {
                  breadcrumb: "รายละเอียด BARCODE",
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_BARCODE_AGENT", "MANAGE_BARCODE_SUB_AGENT"],
                },
              },
            ],
          },
          {
            path: "Order",
            name: "Order",
            component: OrderList,
            meta: {
              breadcrumb: "จัดการข้อมูลการสั่งซื้อ (Order)",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"],
            },
            children: [
              {
                path: "Add",
                component: OrderCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลการสั่งซื้อ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"],
                },
              },
              {
                path: "Detail/:id",
                component: OrderDetail,
                meta: {
                  breadcrumb: "รายละเอียดการสั่งซื้อ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"],
                },
              },
              {
                path: "Edit/:id",
                component: OrderUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลการสั่งซื้อ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_ORDER"],
                },
              },
            ],
          },
          {
            path: "Approver",
            name: "Approver",
            component: ApproverList,
            meta: {
              breadcrumb: "จัดการผู้อนุมัติการเบิกยืมสินค้า",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
            },
            children: [
              {
                path: "Add",
                component: CreateApprover,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลกลุ่มอนุมัติ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                },
                children: [
                  {
                    path: "Agent/:id",
                    component: ApproverAgentInfo,
                    meta: {
                      breadcrumb: "ข้อมูลตัวแทนจำหน่าย",
                      requiredAuth: true,
                      requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                    },
                  },
                  {
                    path: "Employee/:id",
                    component: ApproverEmployeeInfo,
                    meta: {
                      breadcrumb: "ข้อมูลพนักงาน",
                      requiredAuth: true,
                      requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                    },
                  },
                  {
                    path: "User/:id",
                    component: ApproverUserInfo,
                    meta: {
                      breadcrumb: "ข้อมูลผู้อนุมัติ",
                      requiredAuth: true,
                      requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                    },
                  },
                ],
              },
              {
                path: "Edit/:id",
                component: UpdateApprover,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลกลุ่มอนุมัติ",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                },
                children: [
                  {
                    path: "Agent/:id",
                    component: ApproverAgentInfo,
                    meta: {
                      breadcrumb: "ข้อมูลตัวแทนจำหน่าย",
                      requiredAuth: true,
                      requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                    },
                  },
                  {
                    path: "Employee/:id",
                    component: ApproverEmployeeInfo,
                    meta: {
                      breadcrumb: "ข้อมูลพนักงาน",
                      requiredAuth: true,
                      requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                    },
                  },
                  {
                    path: "User/:id",
                    component: ApproverUserInfo,
                    meta: {
                      breadcrumb: "ข้อมูลผู้อนุมัติ",
                      requiredAuth: true,
                      requiredRoles: ["MANAGE_MASTER", "MANAGE_APPROVER"],
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "CompanyProfile",
            component: CompanyProfileList,
            meta: {
              breadcrumb: "จัดการโปรไฟล์บริษัท",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"],
            },
            children: [
              {
                path: "Add",
                component: CreateCompanyProfile,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลโปรไฟล์บริษัท",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"],
                },
              },
              {
                path: "Edit/:id",
                component: UpdateCompanyProfile,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลโปรไฟล์บริษัท",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_COMPANY_PROFILE"],
                },
              },
            ],
          },
          {
            path: "Setting",
            component: Setting,
            meta: {
              breadcrumb: "ตั้งค่าพื้นฐาน",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
            },
          },
          {
            path: "ProductBrand",
            component: ProductBrandList,
            meta: {
              breadcrumb: "จัดการข้อมูลแบรนด์",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"],
            },
            children: [
              {
                path: "Add",
                component: CreateProductBrand,
                meta: {
                  breadcrumb: "เพิ่มแบรนด์",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"],
                },
              },
              {
                path: "Edit/:id",
                component: ProductBrandUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลแบรนด์",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_PRODUCTBRAND"],
                },
              },
            ],
          },
          {
            path: "SalesArea",
            component: SalesAreaList,
            meta: {
              breadcrumb: "จัดการข้อมูลเขตการขาย",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SALESAREA"],
            },
            children: [
              {
                path: "Add",
                component: SalesAreaCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลเขตการขาย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SALESAREA"],
                },
              },
              {
                path: "Edit/:SalesAreaid",
                component: SalesAreaUpdate,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลเขตการขาย",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SALESAREA"],
                },
              },
            ],
          },
          //start ตั้งค่า Alert ถัง-
          {
            path: "OverdueSetting",
            component: OverdueSettingList,
            meta: {
              breadcrumb: "ตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
            },
            children: [
              {
                path: "Add",
                component: CreateOverdueSetting,
                meta: {
                  breadcrumb: "เพิ่มตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
                },
              },
              {
                path: "Edit/:id",
                component: EditOverdueSetting,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลตั้งค่าการแจ้งเตือนคงค้างเกินกำหนดเวลา",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
                },
              },
            ],
          },
          //end ตั้งค่า Alert ถัง-
          //start ตั้งค่า ราคา ถัง-
          {
            path: "MasterProductUnitPrice",
            component: MasterProductUnitPriceList,
            meta: {
              breadcrumb: "ตั้งค่าราคาค่าถัง",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
            },
            children: [
              {
                path: "Add",
                component: CreateMasterProductUnitPrice,
                meta: {
                  breadcrumb: "เพิ่มตั้งค่าราคาค่าถัง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
                },
              },
              {
                path: "Edit/:id",
                component: EditMasterProductUnitPrice,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลตั้งค่าราคาค่าถัง",
                  requiredAuth: true,
                  requiredRoles: ["MANAGE_MASTER", "MANAGE_SETTING"],
                },
              },
            ],
          },
          //end ตั้งค่า ราคา ถัง-
        ],
      },
      {
        path: "/Jobs",
        name: "JobSearch",
        component: JobList,
        meta: {
          breadcrumb: "ใบงาน (Job)",
          requiredAuth: true,
          // requiredRoles: [
          //     "JOB_ADMIN_IMPORT_NEW_ASSETS",
          //     "JOB_ADMIN_PRODUCE",
          //     "JOB_ADMIN_DESTROY",
          //     "JOB_ADMIN_TRANSFER_TO_AGENT",
          //     "JOB_ADMIN_REPAIR_SUPPLIER",
          //     "JOB_ADMIN_TRANSFER_TO_SHOP"
          // ]
        },
        children: [
          {
            path: "Create/RETRIEVE_NEW_ITEM",
            component: JobForm,
            meta: {
              breadcrumb: "รับทรัพย์สินใหม่",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_IMPORT_NEW_ASSETS"],
              jobType: "RETRIEVE_NEW_ITEM",
            },
          },
          {
            path: "Create/PRODUCE",
            component: JobForm,
            meta: {
              breadcrumb: "ผลิตเบียร์สด",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_PRODUCE"],
              jobType: "PRODUCE",
            },
          },
          {
            path: "Create/DESTROY",
            component: JobForm,
            meta: {
              breadcrumb: "ทำลายทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_DESTROY"],
              jobType: "DESTROY",
            },
          },
          {
            path: "Create/TRANSFER_TO_AGENT",
            component: JobForm,
            meta: {
              breadcrumb: "ส่งสินค้าไปยังตัวแทน ฯ",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_TRANSFER_TO_AGENT"],
              jobType: "TRANSFER_TO_AGENT",
            },
          },
          {
            path: "Create/REPAIR_SUPPLIER",
            component: JobForm,
            meta: {
              breadcrumb: "ส่งซ่อมซัพพลายเออร์",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_REPAIR_SUPPLIER"],
              jobType: "REPAIR_SUPPLIER",
            },
          },
          {
            path: "Create/RETURN_SUPPLIER",
            component: JobForm,
            meta: {
              breadcrumb: "รับคืนจากซัพพลายเออร์",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_RETURN_SUPPLIER"],
              jobType: "RETURN_SUPPLIER",
            },
          },
          {
            path: "Create/TRANSFER_TO_SHOP",
            component: JobForm,
            meta: {
              breadcrumb: "ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_TRANSFER_TO_SHOP"],
              jobType: "TRANSFER_TO_SHOP",
            },
          }, 
          {
            path: "Create/TRANSFER_TO_MULTI_SHOP",
            component: JobForm,
            meta: {
                breadcrumb: "ส่งสินค้าไปยังตัวแทนจำหน่ายย่อย/ร้านค้า(หลายร้านค้า)",
                requiredAuth: true,
                requiredRoles: ["JOB_ADMIN_TRANSFER_TO_SHOP"],
                jobType: "TRANSFER_TO_MULTI_SHOP",
            },
          },
          {
            path: "Create/PICKUP",
            component: JobForm,
            meta: {
              breadcrumb: "หยิบสินค้าขึ้นรถ (เร่ขาย)",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_PICKUP"],
              jobType: "PICKUP",
            },
          },
          {
            path: "Create/RETURN",
            component: JobForm,
            meta: {
              breadcrumb: "ส่งสินค้า/ทรัพย์สินคืนต้นทาง",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_RETURN"],
              jobType: "RETURN",
            },
          },
          {
            path: "Create/EXCHANGE",
            component: JobForm,
            meta: {
              breadcrumb: "โอนทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_EXCHANGE"],
              jobType: "EXCHANGE",
            },
          },
          {
            path: "Create/BORROW",
            component: JobForm,
            meta: {
              breadcrumb: "เบิก/ยืมทรัพย์สินเบียร์สด",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_BORROW", "JOB_ADMIN_BORROW_PLANT"],
              jobType: "BORROW",
            },
          },
          {
            path: "Create/RETURN_ADHOC",
            component: JobForm,
            meta: {
              breadcrumb: "รับคืนสินค้า/ทรัพย์สินจากลูกค้า",
              requiredAuth: true,
              requiredRoles: ["JOB_ADMIN_RETURN"],
              jobType: "RETURN_ADHOC",
            },
          },
          {
            path: "Create/AUDIT_STOCK",
            component: JobForm,
            meta: {
              breadcrumb: "ตรวจสอบ STOCK",
              requiredAuth: true,
              requiredRoles: ["super_admin","BR_MANAGE_AUDIT_STOCK","MANAGE_AUDIT_STOCK"],
              jobType: "AUDIT_STOCK",
            },
          },
          // CR-Job-Stock §6.1 Phase 1 — ใบงานตัดยอดคงค้าง (Write-off Outstanding Stock)
          {
            path: "Create/WRITE_OFF_STOCK",
            component: WriteOffStockJobForm,
            meta: {
              breadcrumb: "ตัดยอดคงค้าง",
              requiredAuth: true,
              requiredRoles: ["super_admin", "JOB_ADMIN_WRITE_OFF_STOCK_PLANT"],
              jobType: "WRITE_OFF_STOCK",
            },
          },
          {
            path: "WriteOffStock/Edit/:id",
            component: WriteOffStockJobForm,
            meta: {
              breadcrumb: "แก้ไขใบงานตัดยอดคงค้าง",
              requiredAuth: true,
              requiredRoles: ["super_admin", "JOB_ADMIN_WRITE_OFF_STOCK_PLANT"],
              jobType: "WRITE_OFF_STOCK",
            },
          },
          {
            path: "WriteOffStock/View/:id",
            component: WriteOffStockJobForm,
            meta: {
              breadcrumb: "ดูใบงานตัดยอดคงค้าง",
              requiredAuth: true,
              jobType: "WRITE_OFF_STOCK",
            },
          },
          // {
          //   path: "Create/INVALID_CHECK",
          //   component: JobForm,
          //   meta: {
          //     breadcrumb: "ตรวจสอบข้อมูลทรัพย์สินไม่ถูกต้อง",
          //     requiredAuth: true,
          //     requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"],
          //     jobType: "INVALID_CHECK",
          //   },
          // },
          {
            name: "JobEdit",
            path: "Edit/:id",
            component: JobForm,
            meta: {
              breadcrumb: "แก้ไขใบงาน",
              requiredAuth: true,
              // ไม่ต้องตรวจสอบสิทธิ์ เพราะหากไม่มีสิทธิ์ Server จะไม่ส่งข้อมูลให้
            },
          },
          {
            path: "EditCN/:id",
            component: JobCNForm,
            meta: {
              breadcrumb: "ตรวจสอบแก้ไขข้อมูล CN",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
        ],
      },
      {
        path: "/Borrow",
        name: "ManageBorrowProduct",
        component: ManageBorrowProduct,
        meta: {
          breadcrumb: "เบิก/ยืม ทรัพย์สิน",
          requiredAuth: true,
          requiredRoles: [
            "MANAGE_MASTER",
            "JOB_ADMIN_BORROW",
            "JOB_ADMIN_BORROW_PLANT",
            "JOB_ADMIN_BORROW_APPROVE",
          ],
        },
        children: [
          {
            path: "Add",
            component: CreateBorrowProduct,
            meta: {
              breadcrumb: "เพิ่มข้อมูลเบิก/ยืม ทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: [
                "MANAGE_MASTER",
                "JOB_ADMIN_BORROW",
                "JOB_ADMIN_BORROW_PLANT",
              ],
            },
            children: [
              {
                path: "Picture/:url",
                component: BRPictureModal,
                meta: {
                  breadcrumb: "รูปภาพ",
                  requiredAuth: true,
                  requiredRoles: [
                    "MANAGE_MASTER",
                    "JOB_ADMIN_BORROW",
                    "JOB_ADMIN_BORROW_PLANT",
                  ],
                },
              },
            ]
          },
          {
            path: "Edit/:id",
            component: UpdateBorrowProduct,
            meta: {
              breadcrumb: "แก้ไขข้อมูลเบิก/ยืม ทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: [
                "MANAGE_MASTER",
                "JOB_ADMIN_BORROW",
                "JOB_ADMIN_BORROW_PLANT",
                "JOB_ADMIN_BORROW_APPROVE",
              ],
            },
            children: [
              {
                path: "Picture/:url",
                component: BRPictureModal,
                meta: {
                  breadcrumb: "รูปภาพ",
                  requiredAuth: true,
                  requiredRoles: [
                    "MANAGE_MASTER",
                    "JOB_ADMIN_BORROW",
                    "JOB_ADMIN_BORROW_PLANT",
                  ],
                },
              },
            ],
          },
          {
            path: "Approve/:id",
            component: DetialBorrowProduct,
            meta: {
              breadcrumb: "อนุมัติข้อมูลเบิก/ยืม ทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW_APPROVE"],
            },
          },
          {
            path: "OpenJop/:id",
            component: JobBorrowProduct,
            meta: {
              breadcrumb: "เปิดใบงานเบิก/ยืม ทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"],
            },
          },
          {
            path: "OpenJopReturn/:id",
            component: JobBorrowProductReturn,
            meta: {
              breadcrumb: "ใบงานรับคืนสินค้าจากการเบิก/ยืม ทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: ["MANAGE_MASTER", "JOB_ADMIN_BORROW_OPENJOB"],
            },
          },
        ],
      },
      {
        path: "/Report",
        component: EmptyRouteView,
        exact: true,
        meta: {
          breadcrumb: "รายงาน (Report)",
          requiredAuth: true,
          requiredRoles: [],
        },
        
        children: [
          {
            path: "JobAgentScore",
            component: JobAgentScoreReport,
            meta: {
              breadcrumb: "รายงานคะแนนการทำระบบเบียร์สด",
              requiredAuth: true,
              requiredRoles: ["AGENT_SCORE_ADMIN"],
              requiredProfileTypes: ["COMPANY_PROFILE_TYPE_AGENT"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "AgentScoreEvaluation",
            component: AgentScoreEvaluationReport,
            meta: {
              breadcrumb: "รายงานประเมินตัวแทนจำหน่ายเบียร์สด",
              requiredAuth: true,
              requiredRoles: ["AGENT_SCORE_ADMIN"],
              requiredProfileTypes: ["COMPANY_PROFILE_TYPE_AGENT"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "JobAgentAuditStock",
            component: JobAgentAuditStockReport,
            meta: {
              breadcrumb: "รายงานตรวจสอบ STOCK ตัวแทนจำหน่าย",
              requiredAuth: true,
              requiredRoles: ["MANAGE_AUDIT_STOCK","BR_MANAGE_AUDIT_STOCK","AGENT_REPORT", "super_admin"],
            },
          },
          {
            path: "KegRotationScore",
            component: KegRotationScoreReport,
            meta: {
              breadcrumb: "รายงานคะแนนถังคงค้าง(ผู้ดูแลระบบ)",
              requiredAuth: true,
              requiredRoles: ["AGENT_SCORE_ADMIN"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "KegRotationScoreAgent",
            component: KegRotationScoreAgentReport,
            meta: {
              breadcrumb: "รายงานคะแนนถังคงค้าง(ตัวแทนจำหน่าย)",
              requiredAuth: true,
              requiredRoles: ["AGENT_SCORE_ADMIN"],
              requiredProfileTypes: ["COMPANY_PROFILE_TYPE_AGENT"],
              excludeSuperAdmin: true,
            },
          },
          // {
          //   path: "AgentStockOverdue",
          //   component: AgentStockOverdueReport,
          //   meta: {
          //     breadcrumb: "รายงาน STOCK ระบบเบียร์สด",
          //     requiredAuth: true,
          //     requiredRoles: ["AGENT_REPORT", "super_admin"],
          //   },
          // }, 
          {
            path: "JobRetrieve",
            component: JobRetrieveReport,
            meta: {
              breadcrumb: "รายงานการรับคืนจากตัวแทนจำหน่าย",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "BR_REPORT", "SUB_AGENT_REPORT"],
            },
          },
          {
            path: "AssetProducts",
            component: AssetProductsReport,
            meta: {
              breadcrumb: "รายงานมูลค่าทรัพย์สิน",
              requiredAuth: true,
              requiredRoles: ["BR_REPORT"],
            },
          },
          {
            path: "Movement",
            component: MovementReport,
            meta: {
              breadcrumb: "รายงานความเคลื่อนไหว",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "FixedProducts",
            component: FixedProductsReport,
            meta: {
              breadcrumb: "รายงานประวัติการซ่อมรายบาร์โค้ด",
              requiredAuth: true,
              requiredRoles: ["BR_REPORT"],
            },
          },
          {
            path: "ProduceProducts",
            component: ProduceProductsReport,
            meta: {
              breadcrumb: "รายงานประวัติการผลิตรายบาร์โค้ด",
              requiredAuth: true,
              requiredRoles: ["BR_REPORT"],
            },
          },
          {
            path: "BrandCount",
            component: BrandCountReport,
            meta: {
              breadcrumb: "รายงานการปิดใบงานระหว่างตัวแทนจำหน่ายและโรงงาน",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
            children: [
              {
                path: "BarCode/:id",
                component: BrandCountBarcodeModal,
                meta: {
                  breadcrumb: "รายการบาร์โค้ด",
                  requiredAuth: true,
                  requiredRoles: [
                    "AGENT_REPORT",
                    "SUB_AGENT_REPORT",
                    "BR_REPORT",
                  ],
                },
              },
            ],
          },
          {
            path: "AgentAssets",
            component: AgentAssetsReport,
            meta: {
              breadcrumb: "รายงาน Stock สินค้า รายตัวแทนจำหน่าย",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "ShopAssets",
            component: ShopAssetsReport,
            meta: {
              breadcrumb: "รายงาน Stock สินค้า รายร้านค้า",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT"],
            },
          },
          {
            path: "TransferBarcode",
            component: TransferBarcodeReport,
            meta: {
              breadcrumb: "Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT"],
            },
          },
          {
            path: "TransferBarcodeMultiple",
            component: TransferBarcodeMultipleReport,
            meta: {
              breadcrumb:
                "Stock Card ระหว่างตัวแทนจำหน่ายกับร้านค้า(หลายร้านค้า)",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT"],
            },
          },
          {
            path: "TransferBarcodeSubAgent",
            component: TransferBarcodeSubAgentReport,
            meta: {
              breadcrumb:
                "Stock Card ระหว่างตัวแทนจำหน่ายย่อยกับร้านค้า",
              requiredAuth: true,
              requiredRoles: ["SUB_AGENT_REPORT"],
            },
          },
          {
            path: "TransferBarcodeSupplier",
            component: TransferBarcodeSupplierReport,
            meta: {
              breadcrumb: "ประวัติส่งซ่อม Supplier",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT", "OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"],
            },
          },
          {
            path: "Barcodes",
            component: BarcodesReport,
            meta: {
              breadcrumb: "รายงาน Stock รายบาร์โค้ด",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "AverageBarcode",
            component: AverageBarcodeReport,
            meta: {
              breadcrumb: "รายงานค่าเฉลี่ยกระบวนการภายในโรงงาน/คลังสินค้า",
              requiredAuth: true,
              requiredRoles: ["BR_REPORT"],
            },
          },
          {
            path: "StockBarcodeSnapshot",
            component: StockBarcodeSnapshotReport,
            meta: {
              breadcrumb: "รายงาน Stock Barcode Snapshot",
              requiredAuth: true,
              requiredRoles: ["BR_REPORT"],
            },
          },
          {
            path: "BarcodeStatus",
            component: BarcodeStatusReport,
            meta: {
              breadcrumb: "รายงานสถานะ",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "ProductStocks",
            component: ProductStocksReport,
            meta: {
              breadcrumb: "รายงาน Stock เบิกยืมรายโควตา",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "Borrow",
            component: BorrowReport,
            meta: {
              breadcrumb: "รายงาน การเบิกยืมและยอดคงค้าง Excel",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "PaymentProduct",
            component: PaymentProductReport,
            meta: {
              breadcrumb: "รายงานการจ่ายสินค้า",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "SUB_AGENT_REPORT", "BR_REPORT"],
            },
          },
          {
            path: "ReturnProduct",
            component: ReturnProductReport,
            meta: {
              breadcrumb: "รายงานการรับคืน",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "BR_REPORT"],
            },
          },
        ],
      },
      {
        path: "/AlertReport",
        component: EmptyRouteView,
        exact: true,
        meta: {
          breadcrumb: "รายงานการแจ้งเตือน",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "BeforeDue",
            component: BeforeDue,
            meta: {
              breadcrumb: "คงค้างก่อนครบกำหนดการคืน",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "BR_REPORT", "SUB_AGENT_REPORT"],
            },
          },
          {
            path: "OverdueAll",
            component: OverdueAll,
            meta: {
              breadcrumb: "คงค้างเลยกำหนดการคืน",
              requiredAuth: true,
              requiredRoles: ["AGENT_REPORT", "BR_REPORT", "SUB_AGENT_REPORT"],
            },
          },
        ],
      },
      {
        path: "/AdminReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงานแอดมิน (Report)",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "MasterShopByBrand",
            component: MasterShopByBrandReport,
            meta: {
              breadcrumb: "จำนวนร้านค้าแยกตามแบรนด์",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          // {
          //   path: "PM",
          //   component: PMReport,
          //   meta: {
          //     // breadcrumb: "การล้างเครืองเบียร์สด",
          //     breadcrumb: "ข้อมูลการล้างเครื่องเบียร์สด (PM)",
          //     requiredAuth: true,
          //     requiredRoles: [],
          //   },
          // },
          // {
          //   path: "BarButlerByBrand",
          //   component: BarButlerByBrandReport,
          //   meta: {
          //     // breadcrumb: "ข้อมูลหัวจ่ายแยกตามแบรนด์",
          //     breadcrumb: "ข้อมูลหัวจ่าย",
          //     requiredAuth: true,
          //     requiredRoles: [],
          //   },
          // },
          {
            path: "JobIssue",
            component: JobIssueReport,
            meta: {
              breadcrumb: "การแจ้งปัญหา",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "Survey",
            component: SurveyReport,
            meta: {
              breadcrumb: "Survey PM/MT/QI/MKT(ร้านค้า On/Off premise)",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
        ],
      },
      {
        path: "/QCReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงาน QC",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "QCGroupByAgent",
            component: QIGroupByAgentReport,
            meta: {
              breadcrumb: "รายงานคะแนน QC Group by Agent",
              requiredAuth: true,
              requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI", "AGENT_REPORT", "SUB_AGENT_REPORT"],
            },
          },
          {
            path: "QCGroupByOfficer",
            component: QIGroupByOfficerReport,
            meta: {
              breadcrumb: "รายงานสรุปการเข้าทำ QC Group by เจ้าหน้าที่",
              requiredAuth: true,
              requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"],
            },
          },
        ],
      },
      {
        path: "/PMReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงาน PM",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "AlertPM",
            component: AlertPMReport,
            meta: {
              breadcrumb: "Alert PM (เกินกำหนดการล้างเครื่อง)",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM",  "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "MasterShopOnOff",
            component: MasterShopOnOffReport,
            meta: {
              breadcrumb: "ข้อมูลร้านค้า",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "BarButlerByBrand",
            component: BarButlerByBrandReport,
            meta: {
              // breadcrumb: "ข้อมูลหัวจ่ายแยกตามแบรนด์",
              breadcrumb: "ข้อมูลหัวจ่าย",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "PM",
            component: PMReport,
            meta: {
              // breadcrumb: "การล้างเครืองเบียร์สด",
              breadcrumb: "ข้อมูลการล้างเครื่องเบียร์สด (PM)",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM","SUB_AGENT_ADMIN_PM",  "COOL_SERVICE_PM"],
            },
          },
          {
            path: "PMOperationReport",
            component: PMOperationReport,
            meta: {
              // breadcrumb: "การล้างเครืองเบียร์สด",
              breadcrumb: "รายงาน ปฏิทินบันทึกงาน PM",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "BarcodeMapping",
            component: BarcodeMappingReport,
            meta: {
              // breadcrumb: "การล้างเครืองเบียร์สด",
              breadcrumb: "รายงานจำนวนชุดอุปกรณ์",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM","SUB_AGENT_ADMIN_PM",  "COOL_SERVICE_PM"],
            },
          }, 
          {
            path: "PMSurvey",
            component: PMSurveyReport,
            meta: {
              // breadcrumb: "การล้างเครืองเบียร์สด",
              breadcrumb: "ข้อมูลการ Survey PM",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "PMMonthly",
            component: PMMonthlyReport,
            meta: {
              breadcrumb: "รายงานผลสรุปการบำรุงรักษาเครื่อง (PM) ประจำเดือน",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "MTMonthly",
            component: MTMonthlyReport,
            meta: {
              breadcrumb: "รายงานผลสรุปการซ่อมเครื่อง (MT) ประจำเดือน",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "PMSpare",
            component: PMSpareReport,
            meta: {
              breadcrumb:
                "รายงานผลสรุปการใช้อะไหล่ในการบำรุงรักษาและการซ่อมเครื่อง",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
          {
            path: "PMRoutePlan",
            component: PMRoutePlanReport,
            meta: {
              breadcrumb: "รายงานผลสรุปการบำรุงรักษาเครื่องตามแผนงาน",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM","SUB_AGENT_ADMIN_PM",  "COOL_SERVICE_PM"],
            },
          },
          {
            path: "PMAlertSummary",
            component: PMAlertSummaryReport,
            meta: {
              breadcrumb: "รายงานผลสรุปการแจ้งเตือน",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "SUB_AGENT_ADMIN_PM", "COOL_SERVICE_PM"],
            },
          },
        ],
      },
      {
        path: "/MKTReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงานการตลาด",
          requiredAuth: true,
          requiredRoles: [
            "super_admin",
            "ADMIN_MKT",
            "MANAGER_MKT",
            "USER_MKT",
          ],
        },
        children: [
          {
            path: "EventAndFood",
            component: EventAndFoodReport,
            meta: {
              breadcrumb: "รายงานEvent/มหกรรมอาหาร",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_MKT",
                "MANAGER_MKT",
                "USER_MKT",
              ],
            },
          },
          {
            path: "SurveyOnOffPremise",
            component: SurveyOnOffPremiseReport,
            meta: {
              breadcrumb: "รายงานตรวจเยี่ยมร้าน On/Off-premise",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_MKT",
                "MANAGER_MKT",
                "USER_MKT",
              ],
            },
          },
          {
            path: "NewShopOnOffPremise",
            component: NewShopOnOffPremiseReport,
            meta: {
              breadcrumb: "รายงานเปิดร้านค้าใหม่ On/Off-premise",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_MKT",
                "MANAGER_MKT",
                "USER_MKT",
              ],
            },
          },
        ],
      },
      {
        path: "/5SReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงาน S+",
          requiredAuth: true,
          requiredRoles: [
            "super_admin",
            "ADMIN_5S",
            "AGENT_REPORT",
            "ADVISOR_5S",
            "TEAM_5S",
          ],
        },
        children: [
          {
            path: "TransactionView5S",
            component: TransactionView5SReport,
            meta: {
              breadcrumb:
                "รายงานจำนวนครั้งในการเข้าดูข้อมูลใน S+(E-Learning)",
              requiredAuth: true,
              requiredRoles: ["super_admin", "ADMIN_5S", "TEAM_5S"],
            },
          },
          {
            path: "EvaluateView5S",
            component: EvaluateView5SReport,
            meta: {
              breadcrumb: "จำนวนการประเมินคะแนนประจำเดือน S+",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "AGENT_REPORT",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "WarehouseScore",
            component: WarehouseScoreReport,
            meta: {
              breadcrumb: "รายงานคะแนนโครงการบริหารคลังสินค้าประจำเดือน",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "AGENT_REPORT",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "NotificationKPI",
            component: NotificationKPIReport,
            meta: {
              breadcrumb: "รายงานผลสรุปการแจ้งเตือนไม่ลงข้อมูล KPIs",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "AGENT_REPORT",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
        ],
      },
      {
        path: "/BeerClaimReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงานเบียร์เคลม",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "AmountBeerClaim",
            component: AmountBeerClaimReport,
            meta: {
              breadcrumb: "จำนวนการเคลมเบียร์ประจำเดือน",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "CostBeerClaim",
            component: CostBeerClaimReport,
            meta: {
              breadcrumb: "รายจ่ายในการเคลมเบียร์ (รายปี)",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "StatusBeerClaimMonthly",
            component: StatusBeerClaimMonthlyReport,
            meta: {
              breadcrumb: "สถานะการเคลมคงค้างในกระบวนการประจำเดือน",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
        ],
      },
      {
        path: "/MaintainReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงานช่างซ่อมบำรุง",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "StockPending",
            component: StockPendingReport,
            meta: {
              breadcrumb: "รายงาน Stock รอซ่อม/รอบำรุงรักษา/รอทำลาย/ส่งซ่อมซัพพลายเออร์",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "Checker",
            component: CheckerReport,
            meta: {
              breadcrumb: "รายงาน ส่งมอบหลังซ่อม",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "SparePartsUsed",
            component: SparePartsUsedReport,
            meta: {
              breadcrumb: "รายงาน ข้อมูลการใช้อะไหล่เครื่อง/อุปกรณ์",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "StockSpareParts",
            component: SparePartsStockReport,
            meta: {
              breadcrumb: "รายงาน Stock อะไหล่ทีมช่างซ่อมบำรุง",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "Drawback",
            component: DrawbackReport,
            meta: {
              breadcrumb: "รายงาน รายละเอียด Stock คลังช่าง",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "RepairSum",
            component: RepairSumReport,
            meta: {
              breadcrumb: "รายงาน มูลค่าซ่อม",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "RepairUsage",
            component: ReportRepairUsage,
            meta: {
              breadcrumb: "รายงาน จำนวนการซ่อมเครื่อง/อุปกรณ์",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "QISummary",
            component: ReportQISummary,
            meta: {
              breadcrumb: "รายงาน Summary",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
        ],
      },
      {
        path: "/MachineReport",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "รายงานเครื่องเช่า",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "Invoice",
            component: InvoiceReport,
            meta: {
              breadcrumb: "การวางบิล / การจ่ายเงิน",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "LeaseMachine",
            component: LeaseMachineReport,
            meta: {
              breadcrumb: "สรุปจำนวนเครื่องเช่า",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "MachineDetail",
            component: MachineDetailReport,
            meta: {
              breadcrumb: "รายละเอียดเครื่องเช่า",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
        ],
      },
      {
        path: "/Marketing",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "การตลาด (Marketing)",
          requiredAuth: true,
          requiredRoles: [],
        },
        children: [
          {
            path: "MarketingList",
            component: MarketingList,
            meta: {
              breadcrumb: "ข้อมูลการตลาด",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_MKT",
                "MANAGER_MKT",
                "USER_MKT",
              ],
            },
            children: [
              {
                path: "Detail/:id",
                component: MarketingDetail,
                meta: {
                  breadcrumb: "รายละเอียดข้อมูลการตลาด",
                  requiredAuth: true,
                  requiredRoles: [
                    "super_admin",
                    "ADMIN_MKT",
                    "MANAGER_MKT",
                    "USER_MKT",
                  ],
                },
              },
            ],
          },
          {
            path: "ApproveDetail/:id",
            component: MarketingApproveDetail,
            meta: {
              breadcrumb: "รายละเอียดขอแก้ไขพื้นที่",
              requiredAuth: true,
              requiredRoles: ["super_admin", "ADMIN_MKT", "MANAGER_MKT"],
            },
          },
        ],
      },
      {
        path: "/Kpi",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "ข้อมูล KPI",
          requiredAuth: true,
          requiredRoles: [
            "super_admin",
            "ADMIN_5S",
            "JOB_AGENT_KPI",
            "ADVISOR_5S",
            "TEAM_5S",
          ],
        },
        children: [
          {
            path: "ProductSlow",
            component: ProductSlow,
            meta: {
              breadcrumb: "สินค้าเคลื่อนไหวช้า",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "ProductExpire",
            component: ProductExpire,
            meta: {
              breadcrumb: "สินค้าหมดอายุ",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "ProductLost",
            component: ProductLost,
            meta: {
              breadcrumb: "สินค้าสูญหาย",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "ProductDilapidated",
            component: ProductDilapidated,
            meta: {
              breadcrumb: "สินค้าที่ชำรุดเสียหาย",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "AccessoriesLost",
            component: AccessoriesLost,
            meta: {
              breadcrumb: "อุปกรณ์ส่งเสริมสูญหาย",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "ProductCycle",
            component: ProductCycle,
            meta: {
              breadcrumb: "ถังเปล่าหมุนเวียน",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "DamageMach",
            component: DamageMach,
            meta: {
              breadcrumb: "เครื่องเบียร์สดชำรุด",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "LostMach",
            component: LostMach,
            meta: {
              breadcrumb: "เครื่องเบียร์สดสูญหาย",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "AccessoriesDilapidated",
            component: AccessoriesDilapidated,
            meta: {
              breadcrumb: "อุปกรณ์เบียร์สดสูญหาย",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
          {
            path: "LostTank",
            component: LostTank,
            meta: {
              breadcrumb: "ถังเปล่า/Co2 สูญหาย",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "JOB_AGENT_KPI",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
          },
        ],
      },
      {
        path: "/5S",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "การบริหารคลังสินค้า งาน S+",
          requiredAuth: true,
          requiredRoles: [
            "super_admin",
            "ADMIN_5S",
            "AGENT_E-Learning",
            "ADVISOR_5S",
            "TEAM_5S",
          ],
        },
        children: [
          {
            path: "E-Learning",
            component: ManageELearning,
            meta: {
              breadcrumb: "ข้อมูลการเรียนรู้ (E-Learning)",
              requiredAuth: true,
              requiredRoles: [
                "super_admin",
                "ADMIN_5S",
                "AGENT_E-Learning",
                "ADVISOR_5S",
                "TEAM_5S",
              ],
            },
            children: [
              {
                path: "AddFolder",
                component: FolderELearningModal,
                meta: {
                  breadcrumb: "เพิ่มหมวดหมู่ข้อมูลการเรียนรู้ (E-Learning)",
                  requiredAuth: true,
                  requiredRoles: ["super_admin", "ADMIN_5S"],
                },
              },
              {
                path: "RenameFolder/:id",
                component: FolderELearningModal,
                meta: {
                  breadcrumb: "แก้ไขชื่อหมวดหมู่ข้อมูลการเรียนรู้ (E-Learning)",
                  requiredAuth: true,
                  requiredRoles: ["super_admin", "ADMIN_5S"],
                },
              },
              {
                path: "AddFolder",
                component: UpdateELearning,
                meta: {
                  breadcrumb: "แก้ไขหมวดหมู่ข้อมูลการเรียนรู้ (E-Learning)",
                  requiredAuth: true,
                  requiredRoles: ["super_admin", "ADMIN_5S"],
                },
              },
              {
                path: "Detials/:id",
                component: DetialsELearning,
                meta: {
                  breadcrumb: "รายละเอียดข้อมูลการเรียนรู้ (E-Learning)",
                  requiredAuth: true,
                  requiredRoles: [
                    "super_admin",
                    "ADMIN_5S",
                    "AGENT_E-Learning",
                    "ADVISOR_5S",
                    "TEAM_5S",
                  ],
                },
                children: [
                  {
                    path: "AddSubFolder",
                    component: CreateSubFolderELearningModal,
                    meta: {
                      breadcrumb: "เพิ่มหมวดหมู่ย่อย",
                      requiredAuth: true,
                      requiredRoles: ["super_admin", "ADMIN_5S"],
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/PM",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "งานล้างเครื่องเบียร์สด (PM)",
          requiredAuth: true,
          requiredRoles: [],
          defaultChild: "PMRoutePlan",
        },
        children: [
          {
            path: "PMRoutePlan",
            component: SearchPMRoutePlan,
            meta: {
              breadcrumb: "จัดการ Route Plan/Adhoc",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM","SUB_AGENT_ADMIN_PM"],
            },
            children: [
              {
                path: "Add",
                component: AddPMRoutePlan,
                meta: {
                  breadcrumb: "เพิ่ม Route Plan/Adhoc",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
              },
              {
                path: "Edit/:id",
                component: EditPMRoutePlan,
                meta: {
                  breadcrumb: "แก้ไข Route Plan/Adhoc",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
              },
            ],
          },
          {
            path: "PMCheckIn",
            component: SearchCheckIn,
            meta: {
              breadcrumb: "ข้อมูล Check-in/out PM",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM","SUB_AGENT_ADMIN_PM"],
            },
            children: [
              {
                path: ":id/BarcodeMappingDetail/:id2/:id3",
                component: BarcodeMappingDetail,
                meta: {
                  breadcrumb: "รายละเอียดการจับชุดอุปกรณ์",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
                children: [
                  {
                    path: "Picture/:url",
                    component: PMPictureModal,
                    meta: {
                      breadcrumb: "รูปภาพ",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_PM",
                        "AGENT_ADMIN_PM",
                        "COOL_SERVICE_PM",
                        "SUB_AGENT_ADMIN_PM",
                      ],
                    },
                  },
                ],
              },
              {
                path: ":id/PMDetail/:id2",
                component: PMDetail,
                meta: {
                  breadcrumb: "รายละเอียดการทำ PM",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
                children: [
                  {
                    path: "Picture/:url",
                    component: PMPictureModal,
                    meta: {
                      breadcrumb: "รูปภาพ",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_PM",
                        "AGENT_ADMIN_PM",
                        "COOL_SERVICE_PM",
                        "SUB_AGENT_ADMIN_PM",
                      ],
                    },
                  },
                ],
              },
              {
                path: ":id/MTDetail/:id2",
                component: MTDetail,
                meta: {
                  breadcrumb: "รายละเอียดการทำ MT",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
                children: [
                  {
                    path: "Picture/:url",
                    component: PMPictureModal,
                    meta: {
                      breadcrumb: "รูปภาพ",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_PM",
                        "AGENT_ADMIN_PM",
                        "COOL_SERVICE_PM",
                        "SUB_AGENT_ADMIN_PM",
                      ],
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "PMSurveyCheckIn",
            component: SearchSurveyCheckIn,
            meta: {
              breadcrumb: "ข้อมูล Survey PM",
              requiredAuth: true,
              requiredRoles: ["ADMIN_PM", "AGENT_ADMIN_PM", "COOL_SERVICE_PM","SUB_AGENT_ADMIN_PM"],
            },
            children: [
              {
                path: ":id/PMSurveyBarcodeMappingDetail/:id2/:id3",
                component: PMSurveyBarcodeMappingDetail,
                meta: {
                  breadcrumb: "รายละเอียดการจับชุดอุปกรณ์",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
                children: [
                  {
                    path: "Picture/:url",
                    component: PMPictureModal,
                    meta: {
                      breadcrumb: "รูปภาพ",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_PM",
                        "AGENT_ADMIN_PM",
                        "COOL_SERVICE_PM",
                        "SUB_AGENT_ADMIN_PM",
                      ],
                    },
                  },
                ],
              },
              {
                path: ":id/PMSurveyDetail/:id2",
                component: PMSurveyDetail,
                meta: {
                  breadcrumb: "รายละเอียดการทำ Survey PM",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_PM",
                    "AGENT_ADMIN_PM",
                    "COOL_SERVICE_PM",
                    "SUB_AGENT_ADMIN_PM",
                  ],
                },
                children: [
                  {
                    path: "Picture/:url",
                    component: PMSurveyPictureModal,
                    meta: {
                      breadcrumb: "รูปภาพ",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_PM",
                        "AGENT_ADMIN_PM",
                        "COOL_SERVICE_PM",
                        "SUB_AGENT_ADMIN_PM",
                      ],
                    },
                  },
                ],
              },
               
            ],
          },
        ],
      },
      {
        path: "/BeerClaim",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "เบียร์เคลม (BeerClaim)",
          requiredAuth: true,
          requiredRoles: [],
          defaultChild: "Claim",
        },
        children: [
          {
            path: "Claim",
            component: SearchBeerClaim,
            meta: {
              breadcrumb: "แจ้งเคลมเบียร์",
              requiredAuth: true,
              requiredRoles: [
                "ADMIN_BEER_CLAIM",
                "MANAGER_BEER_CLAIM",
                "QI_OFFICER_BEER_CLAIM",
                "PLANT_ACCOUNTANT_BEER_CLAIM",
                "LAB_BEER_CLAIM",
                "AGENT_ADMIN_BEER_CLAIM",
                "ADMIN_PLANT_BEER_CLAIM",
              ],
            },
            children: [
              {
                path: "Add",
                component: AddBeerClaim,
                meta: {
                  breadcrumb: "ใบคำร้องขอ Claim เบียร์สด",
                  requiredAuth: true,
                  requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"],
                },
                children: [
                  {
                    path: "AddItem/:id",
                    component: AddBeerClaimItem,
                    meta: {
                      breadcrumb: "เพิ่ม Claim Item",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_BEER_CLAIM",
                        "AGENT_ADMIN_BEER_CLAIM",
                      ],
                    },
                  },
                ],
              },
              {
                path: "Edit/:id",
                component: EditBeerClaim,
                meta: {
                  breadcrumb: "แก้ไขใบคำร้องขอ Claim เบียร์สด",
                  requiredAuth: true,
                  requiredRoles: ["ADMIN_BEER_CLAIM", "AGENT_ADMIN_BEER_CLAIM"],
                },
                children: [
                  {
                    path: "AddItem/:id",
                    component: AddBeerClaimItem,
                    meta: {
                      breadcrumb: "เพิ่ม Claim Item",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_BEER_CLAIM",
                        "AGENT_ADMIN_BEER_CLAIM",
                      ],
                    },
                  },
                  {
                    path: "EditItem/:id",
                    component: AddBeerClaimItem,
                    meta: {
                      breadcrumb: "แก้ไข Claim Item",
                      requiredAuth: true,
                      requiredRoles: [
                        "ADMIN_BEER_CLAIM",
                        "AGENT_ADMIN_BEER_CLAIM",
                      ],
                    },
                  },
                ],
              },
              {
                path: "Detail/:id",
                component: BeerClaimDetail,
                meta: {
                  breadcrumb: "รายละเอียดใบคำร้องขอ Claim เบียร์สด",
                  requiredAuth: true,
                  requiredRoles: [
                    "AGENT_ADMIN_BEER_CLAIM",
                    "QI_OFFICER_BEER_CLAIM",
                    "PLANT_ACCOUNTANT_BEER_CLAIM",
                    "LAB_BEER_CLAIM",
                    "MANAGER_BEER_CLAIM",
                    "ADMIN_BEER_CLAIM",
                  ],
                },
                children: [
                  {
                    path: "ClaimItem/:id",
                    component: BeerClaimItemDetail,
                    meta: {
                      breadcrumb: "รายละเอียด Claim Item",
                      requiredAuth: true,
                      requiredRoles: [
                        "AGENT_ADMIN_BEER_CLAIM",
                        "QI_OFFICER_BEER_CLAIM",
                        "PLANT_ACCOUNTANT_BEER_CLAIM",
                        "LAB_BEER_CLAIM",
                        "MANAGER_BEER_CLAIM",
                        "ADMIN_BEER_CLAIM",
                        "ADMIN_PLANT_BEER_CLAIM",
                      ],
                    },
                  },
                ],
              },
              {
                path: "Commit/:id",
                component: CommitBeerClaim,
                meta: {
                  breadcrumb: "สามารถส่งเคลมได้",
                  requiredAuth: true,
                  requiredRoles: ["ADMIN_BEER_CLAIM", "QI_OFFICER_BEER_CLAIM"],
                },
              },
              {
                path: "Approve/:id",
                component: ApproveBeerClaim,
                meta: {
                  breadcrumb: "อนุมัติการเคลม/ไม่อนุมัติการเคลม",
                  requiredAuth: true,
                  requiredRoles: ["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM"],
                },
              },
              {
                path: "Conclude/:id",
                component: ConcludeApproveBeerClaim,
                meta: {
                  breadcrumb:
                    "สรุปผลการอนุมัติและชดเชย/สรุปผลไม่อนุมัติการเคลม",
                  requiredAuth: true,
                  requiredRoles: ["ADMIN_BEER_CLAIM", "MANAGER_BEER_CLAIM"],
                },
              },
              {
                path: "Result/:id",
                component: ResultBeerClaim,
                meta: {
                  breadcrumb: "ผลอนุมัติการเคลม",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_BEER_CLAIM",
                    "MANAGER_BEER_CLAIM",
                    "AGENT_ADMIN_BEER_CLAIM",
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        path: "/Machine",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "เครื่องเช่า",
          requiredAuth: true,
          requiredRoles: [],
          defaultChild: "machine",
        },
        children: [
          {
            path: "ManagePhase",
            component: ManagePhase,
            meta: {
              breadcrumb: "ข้อมูล Phase",
              requiredAuth: true,
              requiredRoles: [
                "ADMIN_EQUIPMENT_LEASING",
                "USER_EQUIPMENT_LEASING",
              ],
            },
            children: [
              {
                path: "Import",
                component: ImportPhase,
                meta: {
                  breadcrumb: "Import Phase",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_EQUIPMENT_LEASING",
                    "USER_EQUIPMENT_LEASING",
                  ],
                },
              },
              {
                path: "DownloadPhase",
                component: DownloadPhase,
                meta: {
                  breadcrumb: "Download Phase",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_EQUIPMENT_LEASING",
                    "USER_EQUIPMENT_LEASING",
                  ],
                },
              },
            ],
          },
          // {
          //   path: "ImportPhase",
          //   component: ImportPhase,
          //   meta: {
          //     breadcrumb: "Import Phase",
          //     requiredAuth: true,
          //     requiredRoles: [
          //       "ADMIN_EQUIPMENT_LEASING",
          //       "USER_EQUIPMENT_LEASING",
          //     ],
          //   },
          // },
          {
            path: "ManageMachineTransaction",
            component: ManageMachineTransaction,
            meta: {
              breadcrumb: "ข้อมูล เครื่องเช่า",
              requiredAuth: true,
              requiredRoles: [
                "ADMIN_EQUIPMENT_LEASING",
                "USER_EQUIPMENT_LEASING",
              ],
            },
            children: [
              {
                path: "ImportMachine",
                component: ImportMachineTransaction,
                meta: {
                  breadcrumb: "Import เครื่องเช่า",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_EQUIPMENT_LEASING",
                    "USER_EQUIPMENT_LEASING",
                  ],
                },
              },
              {
                path: "Download",
                component: DownloadMachineTransaction,
                meta: {
                  breadcrumb: "Download Machine Transaction",
                  requiredAuth: true,
                  requiredRoles: [
                    "ADMIN_EQUIPMENT_LEASING",
                    "USER_EQUIPMENT_LEASING",
                  ],
                },
              },
            ],
          },
          // {
          //   path: "ImportMachine",
          //   component: ImportMachineTransaction,
          //   meta: {
          //     breadcrumb: "Import เครื่องเช่า",
          //     requiredAuth: true,
          //     requiredRoles: [
          //       "ADMIN_EQUIPMENT_LEASING",
          //       "USER_EQUIPMENT_LEASING",
          //     ],
          //   },
          // },
          {
            path: "SaveBillingMachinePayment",
            component: SaveBillingMachinePayment,
            meta: {
              breadcrumb: "บันทึกข้อมูลการวางบิล",
              requiredAuth: true,
              requiredRoles: [
                "MANAGE_MASTER",
                "MANAGE_MACHINE_TRANSACTION",
                "ADMIN_EQUIPMENT_LEASING",
                "USER_EQUIPMENT_LEASING",
              ],
            },
          },
          {
            path: "PaymentMachinePayment",
            component: PaymentMachinePayment,
            meta: {
              breadcrumb: "บันทึกชำระเงินเครื่องเช่า",
              requiredAuth: true,
              requiredRoles: [
                "MANAGE_MASTER",
                "MANAGE_MACHINE_TRANSACTION",
                "ADMIN_EQUIPMENT_LEASING",
                "USER_EQUIPMENT_LEASING",
              ],
            },
          },
          {
            path: "ListMachine",
            component: ListMachine,
            meta: {
              breadcrumb: "ข้อมูลเครื่องเช่า",
              requiredAuth: true,
              requiredRoles: [
                "MANAGE_MASTER",
                "MANAGE_MACHINE_TRANSACTION",
                "ADMIN_EQUIPMENT_LEASING",
                "USER_EQUIPMENT_LEASING",
              ],
            },
          },
        ],
      },
      {
        path: "/QC",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "QC",
          requiredAuth: true,
          requiredRoles: [],
          defaultChild: "QC",
        },
        children: [
          {
            path: "QCCheckIn",
            component: QICheckInList,
            meta: {
              breadcrumb: "เช็คอินร้านค้า",
              requiredAuth: true,
              requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"],
            },
            children: [
              {
                path: "Detail/:id",
                component: QICheckInDetail,
                meta: {
                  breadcrumb: "รายละเอียดการเช็คอินร้านค้า",
                  requiredAuth: true,
                  requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"],
                },
                children: [
                  {
                    path: "Picture/:url",
                    component: QIPictureModal,
                    meta: {
                      breadcrumb: "รูปภาพ",
                      requiredAuth: true,
                      requiredRoles: ["ADMIN_QI", "MANAGER_QI", "USER_QI"],
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/Maintain",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "งานช่างซ่อมบำรุง",
          requiredAuth: true,
          requiredRoles: [],
          defaultChild: "Maintain",
        },
        children: [
          {
            path: "QIJob",
            component: QIJobList,
            meta: {
              breadcrumb: "ใบงานช่างซ่อม",
              requiredAuth: true,
              requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"],
            },
            children: [
              {
                path: "Detail/:id",
                component: QIJobDetail,
                meta: {
                  breadcrumb: "รายละเอียดใบงานช่างซ่อม",
                  requiredAuth: true,
                  requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"],
                },
              },
              {
                path: "EditDrawback/:id",
                component: QIJobEditDrawback,
                meta: {
                  breadcrumb: "แก้ไขข้อมูล เบิก/คืน อุปกรณ์เบียร์สด",
                  requiredAuth: true,
                  requiredRoles: ["OFFICER_QIMAINTAIN"],
                },
              },
              {
                path: "EditRepair/:id",
                component: QIJobEditRepair,
                meta: {
                  breadcrumb: "แก้ไขข้อมูลการซ่อมอุปกรณ์เบียร์สด",
                  requiredAuth: true,
                  requiredRoles: ["OFFICER_QIMAINTAIN"],
                },
              },
            ],
          },
          {
            path: "Recv",
            component: QIRecvList,
            meta: {
              breadcrumb: "รับเข้าอะไหล่",
              requiredAuth: true,
              requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"],
            },
            children: [
              {
                path: "Detail/:id",
                component: QIRecvDetail,
                meta: {
                  breadcrumb: "รายละเอียดข้อมูลรับเข้าอะไหล่",
                  requiredAuth: true,
                  requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN"],
                },
              },
              {
                path: "Add",
                component: QIRecvCreate,
                meta: {
                  breadcrumb: "เพิ่มข้อมูลรับเข้าอะไหล่",
                  requiredAuth: true,
                  requiredRoles: ["OFFICER_QIMAINTAIN"],
                },
              },
            ],
          },
          {
            path: "Stock",
            component: QIStockList,
            meta: {
              breadcrumb: "อะไหล่คงเหลือรายช่างซ่อม",
              requiredAuth: true,
              requiredRoles: ["OFFICER_QIMAINTAIN", "OFFICER_PLANT_QIMAINTAIN", "LEAD_QIMAINTAIN", "QI_QIMAINTAIN"],
            },
          },
        ],
      },
      {
        path: "/AgentScore",
       component: EmptyRouteView,
        meta: {
          breadcrumb: "บันทึกคะแนน",
          requiredAuth: true,
          requiredRoles: [],
          defaultChild: "JobAgentScore",
        },
        children: [
          {
            path: "JobAgentScore",
            component: AgentScoreList,
            meta: {
              breadcrumb: "จัดการคะแนนตัวแทนจำหน่าย ",
              requiredAuth: true,
              requiredRoles: ["AGENT_SCORE_ADMIN"],
              excludeSuperAdmin: true,
            },
            // children: [
            //   {
            //     path: "Detail/:id",
            //     component: BudgetPlanDetail,
            //     meta: {
            //       breadcrumb: "รายละเอียดงบประมาณ",
            //       requiredAuth: true,
            //       requiredRoles: ["super_admin"],
            //       excludeSuperAdmin: true,
            //     },
            //   },
            // ],
          },
           
        ],
      },
      {
        path: "/Monitoring",
        component: MonitoringHub,
        meta: {
          breadcrumb: "Monitoring",
          requiredAuth: true,
          requiredRoles: [],
          requiredMonitorEmail: true,
        },
        children: [
          {
            path: "ScheduledJobs",
            component: MonitoringScheduledJobs,
            meta: {
              breadcrumb: "Scheduled Jobs",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "SendEmailReportAgent",
            component: MonitoringSendEmailReportAgent,
            meta: {
              breadcrumb: "SendEmailReportAgent — Manage",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            path: "SCVD",
            component: MonitoringScvd,
            meta: {
              breadcrumb: "Stock Cover Days — Manual Ops",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
          {
            // CR-PM-Clear-Image — จำลอง cronjob ลบรูปล้างเครื่อง PM บน GCS
            path: "ClearImage",
            component: MonitoringClearImage,
            meta: {
              breadcrumb: "Clear PM Image — Manual Trigger",
              requiredAuth: true,
              requiredRoles: [],
            },
          },
        ],
      },
      {
        path: "/BudgetPlan",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "งบประมาณ",
          requiredAuth: true,
          defaultChild: "List",
          excludeSuperAdmin: true,
        },
        children: [
          {
            path: "List",
            component: BudgetPlanList,
            meta: {
              breadcrumb: "จัดการข้อมูล CCTR/IO/GL",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
            children: [
              {
                path: "Detail/:id",
                component: BudgetPlanDetail,
                meta: {
                  breadcrumb: "รายละเอียดงบประมาณ",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
            ],
          },
          {
            path: "Detail/:id",
            component: BudgetPlanDetail,
            meta: {
              breadcrumb: "รายละเอียดงบประมาณ",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "Create",
            component: BudgetPlanCreate,
            meta: {
              breadcrumb: "เพิ่มแผนงบประมาณ",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "Edit/:year/:cctrCode",
            component: BudgetPlanCreate,
            meta: {
              breadcrumb: "แก้ไขแผนงบประมาณ",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "View/:year/:cctrCode",
            component: BudgetPlanCreate,
            meta: {
              breadcrumb: "ดูรายละเอียดแผนงบประมาณ",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
              isViewMode: true,
            },
          },
          {
            // CR-BudgetReport ข้อ 4: Budget Approval > รายละเอียดใช้งบประมาณตาม Vendor (Q-D1)
            // ISS-31 (7 ต.ค. 2026): breadcrumb คือหัวเรื่องที่โชว์บนหน้าจอด้วย
            //   จึงต้องตัดคำ "รายงาน" นำหน้าออกให้ตรงกับชื่อรายงานในสเปกและ label เมนู
            path: "Report/Vendor",
            component: VendorUsageReport,
            meta: {
              breadcrumb: "รายละเอียดใช้งบประมาณตาม Vendor",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
          },
          {
            path: "Job",
            component: BudgetPlanJobList,
            meta: {
              breadcrumb: "ใบงาน Budget",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
            children: [
              {
                path: "GroupApprove",
                component: BudgetPlanGroupApprove,
                meta: {
                  breadcrumb: "ตรวจสอบใบงานที่ต้องอนุมัติ",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
              {
                path: "Create",
                component: BudgetPlanJobCreate,
                meta: {
                  breadcrumb: "สร้างใบงานงบประมาณ",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
              {
                path: "View/:id",
                component: BudgetPlanJobCreate,
                meta: {
                  breadcrumb: "ดูรายละเอียดใบงาน",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
              {
                path: "Edit/:id",
                component: BudgetPlanJobCreate,
                meta: {
                  breadcrumb: "แก้ไขใบงานงบประมาณ",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_USER", "BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
            ],
          },
          {
            path: "Monitoring",
            component: BudgetPlanMonitoring,
            meta: {
              breadcrumb: "Monitoring",
              requiredAuth: true,
              requiredRoles: [],
            },
            children: [
              {
                path: "SendApprovalGroup",
                component: BudgetPlanMonitoringSendApprovalGroup,
                meta: {
                  breadcrumb: "Email Monitoring",
                  requiredAuth: true,
                  requiredRoles: [],
                },
              },
              {
                path: "BiSnapData",
                component: BudgetPlanMonitoringBiSnapData,
                meta: {
                  breadcrumb: "BI SnapData",
                  requiredAuth: true,
                  requiredRoles: [],
                },
              },
            ],
          },
          {
            path: "ApproveGroup",
            component: ApproveGroupList,
            meta: {
              breadcrumb: "จัดการข้อมูลผู้อนุมัติ",
              requiredAuth: true,
              requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
              excludeSuperAdmin: true,
            },
            children: [
              {
                path: "Create",
                component: ApproveGroupForm,
                meta: {
                  breadcrumb: "สร้างกลุ่มอนุมัติใหม่",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
              {
                path: "Edit/:id",
                component: ApproveGroupForm,
                meta: {
                  breadcrumb: "แก้ไขกลุ่มอนุมัติ",
                  requiredAuth: true,
                  requiredRoles: ["BUDGET_PLAN_REVIEWER", "BUDGET_PLAN_MANAGER"],
                  excludeSuperAdmin: true,
                },
              },
            ],
          },

        ],
      },
      // CR-StockCoverDays — จัดการข้อมูล Stock Cover Days (Master)
      {
        path: "/StockCoverDays",
        component: EmptyRouteView,
        meta: {
          breadcrumb: "Stock Cover Days",
          requiredAuth: true,
          defaultChild: "List",
        },
        children: [
          {
            path: "List",
            component: StockCoverDaysList,
            meta: {
              breadcrumb: "จัดการข้อมูล Stock Cover Days",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
            },
          },
          {
            path: "Create",
            component: StockCoverDaysCreate,
            meta: {
              breadcrumb: "เพิ่มข้อมูล Stock Cover Days",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
            },
          },
          {
            path: "Edit/:plantCode/:year",
            component: StockCoverDaysDetail,
            meta: {
              breadcrumb: "แก้ไขข้อมูล Stock Cover Days",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
            },
          },
          {
            path: "View/:plantCode/:year",
            component: StockCoverDaysDetail,
            meta: {
              breadcrumb: "ดูข้อมูล Stock Cover Days",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
              isViewMode: true,
            },
          },
          {
            // CR-StockCoverDays Feature 2 — Report Analysis (super_admin sees it, like the Master; no excludeSuperAdmin)
            path: "ReportAnalysis",
            component: StockCoverDaysReportAnalysis,
            meta: {
              breadcrumb: "Report Analysis",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
            },
          },
          {
            // CR-StockCoverDays Feature 3 — Dashboard (แดชบอร์ดผู้บริหาร 6 widgets)
            // gating เดียวกับ Master/Report Analysis (super_admin เห็นด้วย; no excludeSuperAdmin)
            path: "Dashboard",
            component: StockCoverDaysDashboard,
            meta: {
              breadcrumb: "Dashboard",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
            },
          },
          {
            // CR-StockCoverDays Feature 4 — Stock Cover Days Report (Action Plan) · Q-R1 = เมนูแยกที่ 4
            // gating เดียวกับ Master/Report Analysis (super_admin เห็นด้วย; no excludeSuperAdmin)
            path: "Report",
            component: StockCoverDaysReport,
            meta: {
              breadcrumb: "Stock Cover Days Report",
              requiredAuth: true,
              requiredRoles: ["SCVD_ADMIN", "SCVD_VIEWER", "SCVD_TEAM_EDIT"],
            },
          },
        ],
      },
      // CR-FormSummaryStock — พิมพ์เอกสารสรุปข้อมูล > เอกสารสรุปสินค้าคงค้าง
      // NOTE: route "New" ต้องมาก่อน ":documentNo" ไม่งั้น "New" จะถูกจับเป็น param
      {
        path: "/PrintSummary/Barcodes",
        component: FormSummaryStockList,
        meta: {
          breadcrumb: "เอกสารสรุปสินค้าคงค้าง",
          requiredAuth: true,
          requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"],
        },
        children: [
          // 1) "New" ต้องมาก่อน ":documentNo" ไม่งั้นคำว่า New จะถูกจับเป็น param
          {
            path: "New",
            component: FormSummaryStockCreate,
            meta: {
              breadcrumb: "เพิ่มสรุปสินค้าคงค้าง",
              requiredAuth: true,
              requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"],
            },
            children: [
              // 2) Preview ต้องเป็นลูกของ New — หน้า Preview อ่าน state ผ่าน $parent
              //    ถ้าย้ายไปเป็น sibling ของ New แล้ว $parent จะกลายเป็นหน้ารายการ หน้าจะว่าง
              {
                path: "Preview",
                component: FormSummaryStockPreview,
                meta: {
                  breadcrumb: "ตรวจสอบข้อมูล",
                  requiredAuth: true,
                  requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"],
                },
              },
              // ขั้นที่ 3B — ตรวจสอบก่อนสร้างเอกสารรวม (เลือกตัวแทนหลายราย)
              // ต้องเป็นลูกของ New เหมือน Preview เพราะอ่าน state ผ่าน $parent
              {
                path: "GroupPreview",
                component: FormSummaryStockGroupPreview,
                meta: {
                  breadcrumb: "ตรวจสอบข้อมูล (สร้างเอกสารรวม)",
                  requiredAuth: true,
                  requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"],
                },
              },
            ],
          },
          // ขั้นที่ 6 — สรุปผลการสร้างเอกสารรวม (F13)
          //   ต้องมาก่อน ":documentNo" ไม่งั้นคำว่า GroupResult จะถูกจับเป็นเลขที่เอกสาร
          //
          //   รับ batchId ทาง route params ของ named route (ไม่ใช่ query string)
          //   params ที่ส่งแบบ programmatic อยู่แค่ในหน่วยความจำ — refresh หรือเปิด URL ตรงแล้วหาย
          //   ตรงกับ spec ฉบับเซ็น 16/09/2026: "หน้าชั่วคราว แสดงเพียงครั้งเดียว
          //   หากปิดหน้าจอไปแล้ว จะไม่สามารถเปิดหน้าสรุปเดียวกันขึ้นมาดูซ้ำได้"
          //
          //   ⚠ ใช้ $parent ไม่ได้ เพราะ route นี้เป็น sibling ของ "New" ไม่ใช่ลูก
          //     ($parent จึงเป็นหน้ารายการ ไม่ใช่หน้าเลือก Filter)
          {
            path: "GroupResult",
            name: "FormSummaryStockGroupResult",
            component: FormSummaryStockGroupResult,
            meta: {
              breadcrumb: "สรุปผลการสร้างเอกสารรวม",
              requiredAuth: true,
              requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"],
            },
          },
          // 3) route param ต้องอยู่ท้ายสุดเสมอ
          {
            path: ":documentNo",
            component: FormSummaryStockDetail,
            meta: {
              breadcrumb: "เอกสารสรุปสินค้าคงค้าง",
              requiredAuth: true,
              requiredRoles: ["FORM_SUMMARY_STOCK_ADMIN", "FORM_SUMMARY_STOCK_AGENT"],
            },
          },
        ],
      },
    ],
  },
  {
    path: "/Callback",
    name: "Callback",
    component: Callback,
  },
];

let router = new VueRouter({
  mode: "history",
  routes: routes,
  linkActiveClass: "kt-menu__item--active",
  linkExactActiveClass: "kt-menu__item--open",
});

export default router;



// WEBPACK FOOTER //
// ./App/router.js